{
  "account_confirmPassword_error_matchOther": "The passwords need to match",
  "account_confirmPassword_label": "Confirm Password",
  "account_create_account_button": "Create Account",
  "account_create_failed": "Failed to create mypascom account",
  "account_email_error_required": "This field is mandatory",
  "account_email_label": "Email",
  "account_firstname_error_required": "This field is mandatory",
  "account_firstname_label": "First Name",
  "account_lastname_error_required": "This field is mandatory",
  "account_lastname_label": "Last Name",
  "account_locked": "Your account has been locked, please contact support.",
  "account_password_error_minLength": "The password needs to have at least 8 characters",
  "account_password_error_required": "This field is mandatory",
  "account_password_label": "Password",
  "account_resend_email": "Resend E-Mail",
  "account_step_companydetails_headline": "Company Details",
  "account_step_userdetails_headline": "Your Details",
  "account_verify_activating": "Activating your account, please wait.",
  "account_verify_content": "Please click on the link in the email to verify your account.",
  "account_verify_headline": "Thank you! We sent you an email.",
  "activation_not_sent": "Activation email could not be sent",
  "activation_sent": "Activation email has been sent",
  "affiliate_partnership_headline": "Partnership",
  "affiliate_models_headline": "Models",
  "affiliate_specials_headline": "Specials",
  "affiliate_become_partner_headline": "Become a partner",
  "affiliate_become_partner_content_text": "You are an IT company and interested in selling pascom products to your customers? Apply for a pascom partnership today!",
  "affiliate_benefits_headline": "Benefits",
  "affiliate_benefits_content_text": "Have a look at our fair and attractive partner program.",
  "pascom_net_homepage_link_text": "pascom.net",
  "affiliate_company_description_headline": "Company description",
  "affiliate_company_description_content_text": "Please give a short description of your companies field of activity.",
  "affiliate_trading_license_text": "As a partner, you are required to hold a trading licence in order to be able to resell our solutions and products. Please upload your trading licence here.",
  "affiliate_trading_license_headline_at": "Trading Licence",
  "affiliate_trading_license_text_at": "As a partner, you are required to hold a trading licence (e.g., Firmenbuchauszug) in order to be able to resell our solutions and products. Please upload your Commercial Registry Certificate here.",
  "affiliate_trading_license_headline_de": "Trading Licence",
  "affiliate_trading_license_text_de": "As a partner, you are required to hold a trading licence (e.g., Handelsregisterauszug) in order to be able to resell our solutions and products. Please upload your trading licence here.",
  "affiliate_trading_license_headline_ch": "Trading Licence",
  "affiliate_trading_license_text_ch": "As a partner, you are required to hold a trading licence (e.g., Handelsregisterauszug) in order to be able to resell our solutions and products. Please upload your trading licence here.",
  "affiliate_apply_partnership_text": "Apply for a partnership",
  "affiliate_download_brochure_text": "Download brochure",
  "nav_partnership_level": "Level",
  "nav_partnership_test": "Tests",
  "nav_partnership_profile": "Profile",
  "nav_partnership_contracts": "Contracts",
  "partnership_partner_level": "You are <b>{{ partnerLevel }}</b> Partner",
  "partnership_partner_year": "Partner Year",
  "partnership_partner_endofperiod_text": "Only {{ stillDays }} days left until the end of your Partner Year, and you did not meet the requirement for your current Partner Level yet. Please try to fulfill the requirements otherwise you will be downgraded to {{ nextPartnerLevel }} at {{ downgradeDate }}.",
  "partnership_partner_level_certified": "Certified",
  "partnership_partner_level_premium": "Premium",
  "partnership_partner_level_excellence": "Excellence",
  "partnership_partner_level_registered": "Registered",
  "partnership_partner_registered_partner": "Registered Partner",
  "partnership_partner_registered_partner_description": "If you do not fulfill the creteria for a higher Partner Level you will be a Registered Partner without a pascom Partner Listing on our Homepage.",
  "partnership_partner_specials": "Specials",
  "partnership_csp_partner": "CSP Partner",
  "partnership_csp_partner_description": "You have a special contract with pascom. The conditions are defined in your contract.",
  "benefits": "Benefits",
  "partner_pending_headline": "Waiting for admission.",
  "partner_pending_description": "Our sales team will check your partnership submit and you get a email after this state.",
  "partner_page_listing": "Partner Page Listing",
  "15_margin": "15% margin",
  "20_margin": "20% margin",
  "25_margin": "25% margin",
  "10_concurrent_user_nfr": "10 Concurrent User NFR",
  "25_concurrent_user_nfr": "25 Concurrent User NFR",
  "50_concurrent_user_nfr": "50 Concurrent User NFR",
  "free_live_support": "Free Live Support",
  "ac_rev2k_name": "> 2K Revenue",
  "ac_rev2k_help": "More then 2.000,- Euro netto revenue for this or last year. For your advantage Partner discounts will not be taken into account. Only license, subscription and maintenance revenue matters. Year is \"Partner Year\" not \"Calendar Year\".",
  "ac_rev5k_name": "> 5K Revenue",
  "ac_rev5k_help": "More then 5.000,- Euro netto revenue for this or last year. For your advantage Partner discounts will not be taken into account. Only license, subscription and maintenance revenue matters. Year is \"Partner Year\" not \"Calendar Year\".",
  "ac_rev20k_name": "> 20K Revenue",
  "ac_rev20k_help": "More then 20.000,- Euro netto revenue for this or last year. For your advantage Partner discounts will not be taken into account. Only license, subscription and maintenance revenue matters. Year is \"Partner Year\" not \"Calendar Year\".",
  "ac_new1_name": "At least 1 new Subscription",
  "ac_new1_help": "Sell more then 1 new subscription this or last year. Year is \"Partner Year\" not \"Calendar Year\".",
  "ac_new4_name": "At least 4 new Subscriptions",
  "ac_new4_help": "Sell more then 4 new subscriptions this or last year. Year is \"Partner Year\" not \"Calendar Year\".",
  "ac_new5_name": "At least 5 new Subscriptions",
  "ac_new5_help": "Sell more then 5 new subscriptions this or last year. Year is \"Partner Year\" not \"Calendar Year\".",
  "ac_new8_name": "At least 8 new Subscriptions",
  "ac_new8_help": "Sell more then 8 new subscriptions this or last year. Year is \"Partner Year\" not \"Calendar Year\".",
  "ac_new10_name": "At least 10 new Subscriptions",
  "ac_new10_help": "Sell more then 10 new subscriptions this or last year. Year is \"Partner Year\" not \"Calendar Year\".",
  "ac_hp_name": "Homepage",
  "ac_hp_description": "List pascom on your homepage.",
  "ac_hp_help": "List pascom as a partner on your homepage. You can also use our webkit as a source (LINK). If you are done contact sales@pascom.net. They will review your homepage and unlock this achivement for you.",
  "ac_csp_name": "Cloud Service Provider",
  "ac_csp_description": "Host a pascom multitenant system.",
  "ac_csp_help": "Visit the two day onsite CSP training and get live support for your hosted installation for free. We will also mention you as hoster on our partner page. Contact sales@pascom.net for pricing and training dates. This achivement will be unlocked after your successful participation.",
  "ac_excl_name": "pascom Exclusive",
  "ac_excl_description": "Get leads from pascom.",
  "ac_excl_help": "Assure that you have no pascom competitors in your portfolio. This has to be clearly visible at your homepage. In retrun we support you with pascom generated leads for your area. Please write an email to sales@pascom.net. They will review your homepage and unlock this achivement for you.",
  "ac_test_name": "Online Test",
  "ac_test_description": "Pass the online test.",
  "ac_test_help": "Pass the online test available at Partner > Tests (LINK) to unlock this archivement.",
  "ac_training_name": "Onsite Training",
  "ac_training_description": "Visit the pascom onsite training.",
  "ac_training_help": "Boost you knowledgte in a two day training course directly onsite at pascom. Contact sales@pascom.net for pricing and training dates. This achivement will be unlocked after your successful participation.",
  "address_validation_not_reachable": "The service for address validation is currently unavailable",
  "answers_missing": "Answers are missing",
  "app_back": "Back",
  "app_change_password": "Save changes",
  "app_continue": "Continue",
  "app_delete": "Delete",
  "app_details": "Details",
  "app_edit": "Edit",
  "app_logout": "Logout",
  "app_next": "Next",
  "app_save": "Save",
  "app_settings": "Settings",
  "app_update": "Update",
  "appliance_is_expired_already": "Appliance is already expired",
  "appliance_maintenance_expired": "Appliance maintenance expired - update channel cannot be updated.",
  "appliance_not_found": "Appliance not found",
  "appliance_search_placeholder": "Search appliance...",
  "host_search_placeholder": "Search for hosts...",
  "appliance_show_paired": "Show also already paired subscriptions",
  "appliance_subscription_headline": "Appliance Subscription",
  "auth_activate_success": "Successfully activated account",
  "auth_cancel": "Cancel",
  "auth_email": "Email",
  "auth_email_exists": "The email already exists in the system",
  "auth_email_not_exists": "The email does not exist in the system",
  "auth_email_resend_success": "We sent you a new password",
  "auth_enter_email": "Please enter your email",
  "auth_forgot_password": "Forgot your password?",
  "auth_login": "Sign in",
  "auth_password": "Password",
  "auth_resend_password": "Resend",
  "auth_reset_password": "Reset password",
  "auth_reset_password_content": "You have requested to reset your password",
  "auth_reset_password_headline": "Reset your password",
  "auth_reset_sent_content": "Please click on the link in the email to reset your password.",
  "auth_reset_sent_headline": "Thank you! We sent you an email.",
  "auth_reset_sent_message": "Resend reset password email.",
  "auth_signin": "Sign in",
  "auth_signup": "Create new Account",
  "auth_username_error": "Please enter a valid email address",
  "bankaccount_not_linked_to_user": "The bank account is not linked to this user",
  "can_not_enable_mypascom": "Cannot enable mypascom. Please contact support.",
  "change_password_confirmPassword_error_matchOther": "The passwords need to match",
  "change_password_confirmPassword_label": "Retype password",
  "change_password_current_password_error_required": "This field is mandatory",
  "change_password_current_password_label": "Current password",
  "change_password_header": "Change password",
  "change_password_password_error_minLength": "The password needs to have at least 8 characters",
  "change_password_password_error_required": "This field is mandatory",
  "change_password_password_label": "New password",
  "change_password_saved": "New password saved",
  "checkout_summary_accept_terms": "I hereby accept pascom's <a href=\"https://www.pascom.net/terms-and-conditions\" target=\"_blank\">Terms and Conditions</a>",
  "checkout_summary_buy_now": "Buy now",
  "checkout_summary_customer_address": "Customer address",
  "checkout_summary_description": "Description",
  "checkout_summary_discount": "Discount",
  "checkout_summary_headline": "Summary",
  "checkout_summary_hint": "Please check your order",
  "checkout_summary_invoice_address": "Invoice address",
  "checkout_summary_payment_method": "Payment method:",
  "checkout_summary_payment_sepa": "Sepa Core Direct Debit",
  "checkout_summary_payment_wire": "Wire Transfer",
  "checkout_summary_quantity": "Quantity",
  "checkout_summary_subscriptions_renewed": "All subscriptions will be automatically renewed after one year.",
  "checkout_summary_subtotal": "Subtotal",
  "checkout_summary_total": "Total",
  "checkout_summary_type_onsite": "onsite (hosted by you)",
  "checkout_summary_unit_price": "Unit Price",
  "company_city_error_required": "This field is mandatory",
  "company_city_label": "City",
  "company_house_number_label": "House Number",
  "company_companyConfirmation_error_required": "Please confirm that you are buying on behalf of a company.",
  "company_companyConfirmation_label": "I hereby confirm that I am creating this account for the company named above and not for private purposes.",
  "company_contacts_header": "Contacts",
  "company_contacts_invite": "Invite new Contact",
  "company_contacts_search": "Search contacts...",
  "company_contacts_show_disabled": "Show disabled",
  "company_country_error_required": "This field is mandatory",
  "company_country_label": "Country",
  "company_details_form_header": "Company Details",
  "company_details_header": "Your company details",
  "company_invoiceEmail_error_required": "This field is mandatory",
  "company_invoiceEmail_error_email": "Please enter a valid email",
  "company_invoiceEmail_label": "Invoice Email Address",
  "company_electronicInvoiceEmail_error_email": "Please enter a valid email",
  "company_electronicInvoiceEmail_label": "XRechnung Email Address",
  "company_name_error_required": "This field is mandatory",
  "company_name_label": "Company Name",
  "company_street2_label": "Additional address",
  "company_street_error_required": "This field is mandatory",
  "company_street_error_streetNumberSpacing": "A space is required between the street and the house number",
  "company_street_label": "Street",
  "company_vat_label": "VAT Number",
  "company_zip_error_required": "This field is mandatory",
  "company_zip_label": "Zip Code",
  "contact_details_header": "Contact Details",
  "contact_does_not_exist": "Contact does not exist",
  "contact_email_error_required": "This field is mandatory",
  "contact_email_label": "Email",
  "contact_first_name_error_required": "This field is mandatory",
  "contact_first_name_label": "First Name",
  "contact_invite_btn": "Invite",
  "contact_invite_header": "Invite new Contact",
  "contact_last_name_error_required": "This field is mandatory",
  "contact_last_name_label": "Last Name",
  "contact_mypascom_account_admin_description": "Admin: Can additionally invite and manage other users and company data",
  "contact_mypascom_account_admin_label": "Administrator",
  "contact_mypascom_account_description_header": "mypascom Accesslevels",
  "contact_mypascom_account_disabled_description": "Disabled: Disabled for my.pascom.net",
  "contact_mypascom_account_disabled_label": "Disabled",
  "contact_mypascom_account_disabled_note": "Note: You can't invite a disabled contact, but you can disable a contact later.",
  "contact_mypascom_account_enabled_description": "User: A normal my.pascom.net user",
  "contact_mypascom_account_enabled_label": "User",
  "contact_mypascom_account_error_required": "This field is mandatory",
  "contact_mypascom_account_label": "Accesslevel",
  "contact_mypascom_logged_in_user_hint": "This user is currently logged in.",
  "could_not_change_password": "Could not change password",
  "country_code_invalid": "Country code is not valid",
  "customer_add": "Add Customer",
  "customer_add_new_headline": "Add customer",
  "customer_create": "Create Customer",
  "customer_details_headline": "Customer details",
  "customer_has_no_subscriptions": "This customer has no subscriptions",
  "customer_headline": "Your customers",
  "customer_not_exist": "Customer does not exist",
  "customer_search_placeholder": "Search Customers...",
  "customer_select": "Select",
  "customer_subscription_headline": "Customer Subscriptions",
  "customer_subscription_new_button": "Start New Subscription",
  "customer_subscription_search": "Search subscriptions...",
  "customer_subscriptions_headline": "Customer Subscriptions",
  "customer_view_add_subscription": "Add New Subscription",
  "deadline_has_expired": "The deadline has expired.",
  "details": "Details",
  "email_already_exist": "The email already exists in the system",
  "email_already_exists": "Your email address already exists in our system. If you have forgotten your password, please use the 'Reset Password' function.",
  "email_cant_be_emptied": "The email can not be empty",
  "error": "Error",
  "footer_mypascom_name": "<a href=\"https://my.pascom.net/\" target=\"_blank\">my.pascom.net</a> a service of",
  "footer_company_name": "<a href=\"https://www.pascom.net/\" target=\"_blank\">pascom</a>",
  "info": "Info",
  "instance_name_changename_hint": "The name can NOT be changed later. Please make sure to select a proper name now. It will be also visible to all your users. Use your company name for instance.",
  "instance_name_pattern_hint": "Please use only lowercase for the name. Permitted characters include: a-z, 0-9 and - . The first four characters must be letters and the name can only be a maximum of 20 characters long!",
  "instance_name_too_long": "At maximum 20 characters are allowed for a pascom instance name",
  "fqdn_too_long": "At maximum 80 characters are allowed for a FQDN",
  "instancename_headline": "Select a name",
  "onsitename_name_error_maxLength": "At maximum 20 characters are allowed for a pascom instance name",
  "instancename_name_error_maxLength": "At maximum 20 characters are allowed for a pascom instance name",
  "instancename_name_error_pattern": "This instance name is invalid. Make sure that it starts with 4 letters, e. g.: abcd123. Please use only lowercase.",
  "instancename_name_error_required": "You need to choose an instance name",
  "instancename_name_label": "https://pascom.cloud/",
  "instancename_pattern_hint": "The name will be used to access your instance in the pascom cloud.",
  "instancename_pattern_hint_onsite": "This name will be shown in my.pascom.net",
  "invalid_appliance": "Invalid appliance",
  "invalid_appliance_id": "Invalid appliance ID",
  "invalid_appliance_type": "Invalid appliance type",
  "invalid_country_data": "Invalid country data",
  "invalid_customer": "Invalid customer",
  "invalid_data": "Invalid data",
  "invalid_email": "Invalid email",
  "invalid_iban": "IBAN is not valid",
  "invalid_licence": "Invalid licence",
  "invalid_mac_address": "Invalid mac address",
  "invalid_parameters": "Invalid parameters",
  "invalid_payment_method": "Invalid payment method",
  "invalid_pool_key": "Invalid pool_key",
  "invalid_pool_pass": "Invalid pool_pass",
  "invalid_product": "Invalid product",
  "invalid_product_category": "Invalid product category",
  "invalid_product_level": "Invalid product level",
  "invalid_sale_order": "Invalid sale order",
  "invalid_systemid": "Invalid System-ID.",
  "invalid_token": "Invalid token",
  "invoice_headline": "Invoice address",
  "language_code": "en_US",
  "language_code_invalid": "Language code is invalid or language is not supported.",
  "language_code_missing": "Language code is missing",
  "legacy_activation_name_error_required": "This field is mandatory",
  "legacy_activation_name_label": "Name",
  "legacy_activation_systemid_error_required": "This field is mandatory",
  "legacy_activation_systemid_label": "System-ID",
  "licence_already_paired": "This licence is already paired",
  "licence_can_not_be_paired": "This license type cannot be paired",
  "licence_not_in_pairing_status": "This license is not in pairing status",
  "loggedin_user_has_no_company": "The current user has no company",
  "max_attempts_reached": "Max attempts is reached.",
  "my_subscription_headline": "My Subscriptions",
  "mypascom_admin": "Admin",
  "mypascom_disabled": "No mypascom Access",
  "mypascom_enabled": "User",
  "maintenance_api_unavailable_headline": "Service not reachable at the moment",
  "maintenance_api_unavailable_description": "Our service is not reachable at the moment. We will try to reconnect. This will take a moment.",
  "maintenance_api_unavailable_takes_longer_description": "It takes longer then expected, but we will continue to try it. You can use the refresh button to go back to the main page.",
  "maintenance_api_unavailable_refresh_button": "Refresh to main page",
  "nav_company_contacts": "Contacts",
  "nav_company_details": "Company",
  "nav_subscriptions_customer": "Customer Subscriptions",
  "nav_subscriptions_my": "My Subscriptions",
  "navigation_company": "Company",
  "navigation_customers": "Customers",
  "navigation_dashboard": "Dashboard",
  "navigation_logout": "Logout",
  "navigation_partner": "Partner",
  "navigation_agreement": "Agreements",
  "navigation_subscriptions": "Subscriptions",
  "navigation_partner_downloads": "Partner Downloads",
  "navigation_support": "Support",
  "navigation_integration_apps": "Integration Apps",
  "no_active_subscription": "Appliance has no active subscription",
  "no_company_for_user": "No company for signed in user",
  "no_licence": "No licence",
  "no_more_free_allowed": "Sorry, but you are not allowed to have more than *two* FREE subscriptions. Please delete a FREE or buy a Basic or Premium subscription.",
  "no_related_company": "User has no related company.",
  "not_a_partner": "Your company is currently not a partner",
  "not_allowed_to_access_sale_order": "You are not allowed to access this sale order",
  "not_authorized": "Your are not authorized to perform this action",
  "onsitename_name_error_pattern": "This instance name is invalid. Make sure that it starts with 4 letters, e. g.: abcd123. Please use only lowercase.",
  "onsitename_name_error_required": "You need to choose an instance name",
  "onsitename_name_label": "Name",
  "paired": "Paired",
  "pending": "Pending",
  "password_confirmPassword_error_matchOther": "The passwords need to match",
  "password_confirmPassword_error_required": "This field is mandatory",
  "password_confirmPassword_label": "Retype new password",
  "password_length": "Passwords must be a minimum of 8 characters.",
  "password_password_error_minLength": "The password needs to have at least 8 characters",
  "password_password_error_required": "This field is mandatory",
  "password_password_label": "New password",
  "passwords_not_match": "Passwords do not match",
  "payment_details_form_header": "Payment Details",
  "payment_method_hint": "Please select your preferred payment method.",
  "payment_method_invoice": "Invoice",
  "payment_method_label": "Payment Method",
  "payment_method_sepa": "SEPA Core Direct Debit",
  "payment_sepa_account_error_required": "This field is mandatory",
  "payment_sepa_account_label": "Account Holder",
  "payment_sepa_iban_error_required": "This field is mandatory",
  "payment_sepa_iban_label": "IBAN",
  "product_basic_description": "Ideal for companies with IT support!",
  "product_buy_basic": "Buy now",
  "product_buy_free": "Start for free",
  "product_buy_premium": "Buy now",
  "product_feature_all": "All Features",
  "product_feature_emailsupport": "Email Support",
  "product_feature_forumsupport": "Forum Support",
  "product_feature_hosting": "Hosting included",
  "product_feature_phonesupport": "Telephone support",
  "product_feature_phone_email_support": "Telephone & email support",
  "product_feature_sla_option": "SLA Options",
  "product_feature_remotesupport": "Remote Support",
  "product_free_description": "2 license seats completely free, forever! Ideal for beginners and small companies.",
  "product_not_exist": "The specified product does not exist",
  "product_premium_description": "Ideal for companies who want to use our pascom support directly and to the full extent.",
  "product_select_concurrent_user": "Concurrent user",
  "product_select_content": "You have currently \"{{option}}\". Subscription renews in {{days}} days (remaining period).",
  "sla_product_select_content": "You currently have a \"{{slaOption}}\" service level agreement.",
  "product_select_headline": "Select Product",
  "sla_product_select_headline": "Choose SLA Option",
  "product_not_allowed": "The selected product is not allowed to be added via this function",
  "product_select_hint": "Get a license for two concurrent users for free or buy a product with more users or better support level.",
  "product_select_info": "** You can upgrade your subscription at any point in time by just paying the difference for the remaining period.",
  "product_select_licenses": "Licenses",
  "product_select_subheadline": "Choose your upgrade option",
  "product_select_upgrade_price": "Upgrade price**",
  "product_select_sla_option": "SLA Option",
  "profile_add_new": "Add new Profile",
  "profile_already_added": "Profile is already added.",
  "profile_city_error_required": "This field is mandatory",
  "profile_city_label": "City",
  "profile_country_error_required": "This field is mandatory",
  "profile_country_label": "Country",
  "profile_details_header": "Website Profile",
  "profile_hint": "Your website profile will be visible at the pascom partner search portal.",
  "profile_load_image_failed": "Failed to load image",
  "profile_website_error_required": "This field is mandatory",
  "profile_website_label": "Website URL",
  "profile_zip_error_required": "This field is mandatory",
  "profile_zip_label": "ZIP",
  "reset_password_sent": "Reset password email has been sent.",
  "reset_password_unsuccessfull": "Reset password was unsuccessfull.",
  "sale_order_no_lines": "Sale order has no lines",
  "select_appliance_license_hint": "Select an existing subscription to pair with your appliance or create a new subscription",
  "select_customer_create": "Create",
  "select_customer_or": "or",
  "select_customer_select_or_create": "Select or create customer",
  "select_hosting_headline": "Select hosting",
  "select_hosting_hint": "Please select if you want pascom.cloud (hosted by pascom) or onsite (hosted by you). Select also onsite if you want to use another (non pascom) hosting service like Amazon or Google.",
  "select_hosting_hint_csp": "Please select your preferred hosting option: CSP host (hosted on your CSP instance) or pascom.cloud (pascom hosted) or on-premise (hosted by you). Please select on-premise hosting should you wish to use a different hosting service (i.e. not pascom) such as Amazon or Google.",
  "select_hosting_onsite": "Select onsite hosting (hosted by you)",
  "select_hosting_or": "or",
  "select_hosting_pascom_cloud": "Select pascom.cloud",
  "sign_in_failed": "Sign in failed",
  "site_name_missing": "Site name is missing",
  "subscription_concurrent_users": "<b>{{licType}}</b> with <b>{{userNumber}}</b> Concurrent Users",
  "subscription_concurrent_users_without_lictype": "Concurrent Users",
  "subscription_users": "Users",
  "subscription_details": "Subscription details",
  "subscription_license": "License",
  "subscription_license_details": "License details",
  "subscription_support": "Support",
  "subscription_upgrade_plan": "Upgrade plan",
  "subscriptions": "Subscriptions",
  "subscriptions_show_expired": "Show expired",
  "success": "Success",
  "systemid_in_use": "System-ID is already in use",
  "test_failed": "Test is failed",
  "test_id_missing": "Test ID is missing",
  "test_is_missing": "Test is missing",
  "test_not_passed": "Test is not passed this time.",
  "test_not_started": "Test cannot be started.",
  "test_passed": "Test is passed",
  "thank_you_cloud_back": "Back to my.pascom.net",
  "thank_you_cloud_content": "We will send you an email with all the details when your cloud instance is ready! Alternatively, stay tuned!",
  "thank_you_cloud_goto": "Go to my appliance",
  "thank_you_cloud_headline": "Give us 2 minutes to prepare your new cloud instance",
  "thank_you_cloud_headline2": "Your instance is ready, please follow the link below",
  "thank_you_onsite_content": "Go ahead now and install your onsite appliance. You can pair your appliance with this subscription by following the instructions of the appliance setup wizard.",
  "thank_you_onsite_documentation": "Show me the documentation",
  "thank_you_onsite_headline": "Thank you!",
  "thank_you_onsite_pascom": "Continue",
  "type": "Type",
  "update_channel_not_found": "Update channel not found",
  "user_does_not_exist": "User does not exist",
  "user_not_activated": "User is not activated",
  "user_not_exists_or_activated": "User does not exist or is already activated",
  "user_not_authenticated": "User is not authenticated",
  "valid_until": "Valid until",
  "vat_invalid": "VAT is invalid",
  "verify_message_resent": "We sent you a new activation email",
  "warning": "Warning",
  "website_profile_logo_max_size": "Maximum size of logo is 720x720px.",
  "website_profile_url_https": "Website URL must start with http:// or https://.",
  "wrong_current_password": "Wrong current password",
  "reset_password_password_label": "New Password",
  "reset_password_password_error_required": "This field is mandatory",
  "reset_password_confirmPassword_label": "Confirm new Password",
  "reset_password_confirmPassword_error_matchOther": "The passwords must match",
  "pair_appliance": "Pair",
  "unpair_appliance": "Unpair",
  "subscription_new_button": "Add Subscription",
  "no_paired_license": "This system has no paired license",
  "price_per_year": "per year",
  "price_concurrent_user": "Concurrent user",
  "price_license_included": "{{users}} License included",
  "price_licenses": "{{users}} Licenses",
  "contact_invite_welcome": "Welcome {{name}}",
  "contact_invite_headline": "You have been invited to mypascom.",
  "contact_invite_text": "Please pick a password to login to your company.",
  "contact_invite_activate_button": "Activate my account",
  "subscription_license_code_docs": "How to apply the license code?",
  "subscription_license_code_copy_button": "Copy to clipboard",
  "subscription_license_code_headline": "License Code",
  "subscription_license_code_systemid_docs": "Where can I find the System-ID?",
  "subscription_license_code_pair_legacy_button": "Pair Appliance",
  "subscription_pairing_state_headline": "Pairing",
  "subscription_paired_with_text": "This subscription is paired with the appliance hostname {{name}}",
  "subscription_in_pairing_process": "This subscription is currently in pairing process.",
  "subscription_not_paired": "This subscription is currently not paired.",
  "subscription_docs_link": "Read more in the docs",
  "subscription_support_headline": "Support",
  "subscription_has_email_support": "This subscription has Email Support. Login to our Ticket System to open a Support Request.",
  "subscription_has_live_support": "This subscription has Live Support. Login to our Ticket System to open a Support Request.",
  "subscription_has_premium_support": "This subscription has Premium Support. Login to our Ticket System to open a Support Request.",
  "subscription_has_basic_support": "This subscription has Forum Support. Create an account in our forum if you need help.",
  "subscription_open_ticketsystem": "pascom Ticket System",
  "subscription_open_forum": "Open Forum",
  "subscription_updatechannel_headline": "Update Channel",
  "subscription_updatechannel_change_button": "Change Channel",
  "subscription_updatechannel_download_legacy_updater": "Download Legacy Updater",
  "subscription_updatechannel_download_offline_update": "Download Offline Update",
  "subscription_updatechannel_download_lic": "Download License file",
  "subscription_update18_headline": "Upgrade to pascom18",
  "subscription_update18_text": "The License attached to this Appliance is only suitable for pascom versions up to 17. If you want to upgrade your Appliance to 18 and above follow the instructions in our <a href=\"https://www.pascom.net/doc/en/server/upgrade/\">Documentation</a>.",
  "subscription_type": "Type:",
  "subscription_url": "Url:",
  "license_code": "License code",
  "license_file": "License file",
  "language_english": "Switch to English",
  "language_german": "Wechsle zu Deutsch",
  "concurrent_user_link": "https://www.pascom.net/en/voip-prices/#concurrent-user",
  "sla_option_link": "https://www.pascom.net/en/voip-prices/#sla-options",
  "delete_free_button": "Delete",
  "app_yes": "Yes",
  "app_no": "No",
  "confirm_delete_free": "Are you sure?",
  "welcome_headline": "Welcome Back {{name}}",
  "welcome_text": "You successfully verified your account!",
  "welcome_continue_button": "Continue",
  "thank_you_upgrade_content_onsite": "Your subscription has been upgraded. If necessary, go to your appliance and refresh your license.",
  "thank_you_upgrade_content_cloud": "Your subscription has been upgraded and will be available in your instance soon.",
  "thank_you_upgrade_headline": "Thank you!",
  "thank_you_upgrade_pascom": "Continue",
  "saleorder_already_confirmed": "This purchase has already been confirmed and can't be modified anymore",
  "checkout_summary_tax": "VAT",
  "contact_saved": "Contact saved",
  "contact_save_error": "Failed to save contact",
  "contact_invited": "Contact has been invited",
  "contact_created": "Contact has been created",
  "create_offer_please_wait": "Please wait",
  "no_subscriptions": "Currently we could not find any subscriptions.",
  "no_agreements": "Currently we could not find any agreements.",
  "agb_link": "https://www.pascom.net/wp-content/uploads/GTCsEN.pdf",
  "subscription_license_code_copied": "Copied!",
  "not_in_workflow_link": "Invalid url. Go back to my.pascom.net",
  "expired_since": "Expired since",
  "support_phone_dialable": "+4999129691300",
  "support_phone_btn": "Call +49 991 29691 300",
  "auth_resend_invitation_email": "Resend invitation email",
  "invitation_not_sent": "Invitation email could not be sent",
  "contact_mypascom_not_activated_yet": "This contact is not activated yet, you can send a new invitation email to this contact by clicking the button below.",
  "subscription_onsite_perpetual": "A onsite perpetual license can not be updated via mypascom, please contact pascom sales.",
  "vat_is_mandatory": "VAT is mandatory",
  "vat_is_invalid": "VAT is invalid",
  "company_vat_error_required": "This field is mandatory",
  "app_download_attachment": "Download the attachment",
  "agreement_accept_ack": "Taken note of",
  "agreement_accept_contract": "Sign contract",
  "app_agreements": "Agreements",
  "agreements_list_headline": "Agreements",
  "attachments": "Attachments",
  "agreement_signed_on": "Signed on: {{date}}",
  "peoplefone_email_label": "E-Mail Address",
  "peoplefone_email_error_required": "E-Mail is mandatory",
  "peoplefone_first_name_label": "First Name",
  "peoplefone_first_name_error_required": "First name is mandatory",
  "peoplefone_last_name_label": "Last Name",
  "peoplefone_last_name_error_required": "Last name is mandatory",
  "peoplefone_street_name_label": "Street",
  "peoplefone_street_name_error_required": "Street is mandatory",
  "peoplefone_house_number_label": "House Number",
  "peoplefone_house_number_error_required": "House Number is mandatory",
  "peoplefone_zip_code_label": "ZIP Code",
  "peoplefone_zip_code_error_required": "ZIP Code is mandatory",
  "peoplefone_city_label": "City",
  "peoplefone_city_error_required": "City is mandatory",
  "peoplefone_country_label": "Country",
  "peoplefone_country_error_required": "Country is mandatory",
  "peoplefone_company_name_label": "Company Name",
  "peoplefone_company_name_error_required": "Company Name is mandatory",
  "peoplefone_username_already_exists": "The entered E-Mail address is already registered at peoplefone",
  "peoplefone_error": "Failed to create peoplefone test account",
  "peoplefone_api_error": "The peoplefone api returned an error",
  "peoplefone_malformed_response": "The peoplefone api returned a malformed response",
  "peoplefone_request_failed": "Unknown error while creating peoplefone test account",
  "peoplefone_register_headline": "Register test account",
  "peoplefone_create_btn": "Create test account",
  "peoplefone_register_success_headline": "Test account created sucessfully!",
  "peoplefone_register_success_html": "After finishing the setup, your pbx can be called via the phone number below.<br/>Use the <a href='https://me.peoplefone.de/'>peoplefone web access</a> to extend your peoplefone account or to recharge it.",
  "peoplefone_account_data_alert": "Please write down the data below securely! The peoplefone web access account data is not stored in mypascom and will be lost as soon as you leave this page.",
  "peoplefone_phone_number": "Your Phone Number",
  "peoplefone_username": "Username (Peoplefone Web Access)",
  "peoplefone_password": "Password (Peoplefone Web Access)",
  "peoplefone_continue_setup_btn": "Continue",
  "peoplefone_download_template_btn": "Download Trunk Template",
  "peoplefone_testaccount_html": "Our SIP-Provider-Partner <a href='https://www.peoplefone.de' target='_blank'>peoplefone</a> provides you a free test account with a <b>german fixed network phone number</b> and <b>€ 10</b> starting balance.<br/>The setup is fully automatic and usable immediately.",
  "peoplefone_testaccount_headline": "peoplefone test account",
  "peoplefone_gender_label": "Salutation",
  "peoplefone_gender_error_required": "Salutation is mandatory",
  "peoplefone_gender_male": "Mr.",
  "peoplefone_gender_female": "Mrs.",
  "app_clipboard_copy_successful": "Copied data",
  "app_copy_to_clipboard": "Copy to clipboard",
  "peoplefone_url": "Peoplefone Web Access",
  "peoplefone_saved_data": "I saved the Account data",
  "partner_test_training_resources": "Training Resources",
  "partner_test_already_passed": "Already passed!",
  "partner_test_attempts": "Attempts: {{attempts}} of {{max_attempts}}",
  "partner_test_deadline": "Due until:",
  "partner_test_status": "Status:",
  "partner_test_status_open": "Open",
  "partner_test_status_passed": "Passed",
  "partner_test_status_failed": "Failed",
  "partner_test_status_overdue": "Overdue",
  "partner_test_cancel": "Cancel Test",
  "partner_test_possible_answers": "Possible Answers: {{num}}",
  "partner_test_previous_question": "Previous",
  "partner_test_next_question": "Next",
  "partner_test_question_position": "Question {{current}} of {{max}}",
  "partner_test_confirm_submit_text": "Last Chance! Submit your test?",
  "partner_test_doublecheck_btn": "Let me double check the questions again",
  "partner_test_submit_btn": "I am brave, SUBMIT!",
  "partner_test_successful": "HURRAY! You are a pascom pro.",
  "partner_test_unsuccessful": "This didn't work, you need to retry the test",
  "partner_test_failed": "Unfortunately, you failed completely.",
  "partner_test_back_to_overview_btn": "Back to the test page",
  "partner_test_headline": "Partnership Tests",
  "agreement_search": "Search agreements",
  "agreement_info": "Info",
  "agreement_ack": "Acknowledgements",
  "agreement_contract": "Partner Contract",
  "agreement_not_signed": "Agreement is not signed",
  "button_agreement_keep_instance": "Keep",
  "button_agreement_delete_instance": "Delete",
  "partner_test_start_btn": "Start",
  "app_print": "Print",
  "render_error": "Attachment could not be rendered",
  "agreement_show_outdated": "Show outdated",
  "trading_license_filesize_exceeded": "File too big. Maximum allowed size is 10Mib",
  "trading_license_wrong_filetype": "The file you selected is not a PDF",
  "partner_add_nfr_btn": "Get NFR Subscription",
  "affiliate_still_chars": "Still at least {{number}} characters",
  "invalid_bankaccount_data": "Invalid bank account data",
  "agreement_keep_instance": "Your instance '{{applianceName}}' with ID '{{applianceId}}' is idle since {{idleDays}} days. Do you wanna keep your instance? If no we automatically delete this instance!",
  "agreement_free_idle_content": "Appliance: '{{applianceName}}', ID: '{{applianceId}}', outcome: {{result}}",
  "peoplefone_acceptTC": "I hereby accept the <a href=\"https://www.peoplefone.ch/en/terms-and-conditions\" target=\"_blank\">Terms and Conditions</a> of the peoplefone and I agree with the transmission of the given data to peoplefone.<br />According to German law (§111 TKG), you are obliged to use only chargeable addresses when setting up telecommunication accounts. peoplefone is entitled to delete customer accounts for which a verification is unsuccessful without consulting.",
  "partner_add_csphost_btn": "Add CSP Host",
  "csphost_select_name_header": "Choose Subscription Name",
  "csphost_select_name_hint": "Choose a name for your csp subscription. You can use the hostname of the target system.",
  "instance_name_changename_hint_csphost": "This name cannot be changed afterwards",
  "csphost_create": "Create Subscription",
  "csphost_name_label": "FQDN",
  "csphost_name_error_required": "This field is mandatory",
  "csphost_name_error_pattern": "A CSP Hostname needs to be a valid FQDN",
  "csphost_select_host_header": "Select CSP Host",
  "csphost_select_host_hint": "Please select a host the new appliances should run on",
  "csphost_select_host_btn": "Select",
  "instancename_pattern_hint_csp": "You can access the new instance via this name later on your csp host",
  "cspinstance_name_label": "Name",
  "cspinstance_name_error_required": "This field is mandatory",
  "cspinstance_name_error_pattern": "The instancname need to match the pattern. Please use only lowercase.",
  "subscription_csp_childs_header": "Child Instances ({{count}})",
  "subscription_add_csp_instance_btn": "Add a Child Instance",
  "select_hosting_csp": "Select a CSP Host",
  "subscription_csp_parent": "On CSP Host",
  "thank_you_csp_content": "Go back to your CSP Host. You may need to refresh the license for the instance to be installed",
  "choose_profile_image_file": "Choose a image to upload",
  "profile_logo": "Profile Logo",
  "profile_no_profile_image": "No image set",
  "csphost_child_count": "Child instances: {{count}}",
  "product_select_partner_discount_not_included": "Partner discount is not included in the upgrade price.",
  "product_please_select": "-- Please Select --",
  "product_none_selected": "Please select a valid premium or basic subscription",
  "checkout_summary_type_cloud_host": "cloud (hosted on {{host}})",
  "subscription_next_invoice": "Next invoice:",
  "subscription_cancelled": "Cancelled on:",
  "blacklisted_data": "Your data is blacklisted. If you think that is a mistake, please contact our sales team.",
  "iban_in_use": "IBAN already is in use",
  "company_update_success_summary": "Company details saved!",
  "company_update_success_detail": "Your settings on company details have been saved.",
  "company_update_error_summary": "Saving the company details failed!",
  "company_update_error_detail": "Your settings on company details failed to save. Please check your settings and try again.",
  "company_bankaccount_update_success_summary": "Bank account details saved!",
  "company_bankaccount_update_success_detail": "Your settings for the company's bank account have been saved.",
  "company_bankaccount_update_error_summary": "Saving the bank account details failed!",
  "company_bankaccount_update_error_detail": "Your settings for the company's bank account failed to save. Please check your settings and try again.",
  "peoplefone_api_maintenance": "Due to maintenance, creation of peoplefone test accounts has been temporarily suspended.",
  "agreement_siptrunk_content": "Provider: '{{provider}}' Customer-Id: '{{customer_id}}'",
  "invalid_siptrunk_provider": "The supplied provider is not supported",
  "siptrunk_agreement_already_exists": "There is already a SIP Trunk Test Account for this instance",
  "too_many_siptrunk_agreements": "The number of allowed SIP Trunk Test Accounts has been exceeded",
  "failed_to_create_agreement": "Error while creating agreement for SIP Trunk Test Account",
  "error_preparing_sip_trunk_test_account": "An error occured while preparing data for the sip trunk test account",
  "failed_to_parse_sip_trunk_testaccount_response": "An invalid response occured while preparing data for the sip trunk test account",
  "no_agreement_id_in_response": "Failed to create test account, the response did not contain an agreement id",
  "peoplefone_account_already_exists": "There is already a SIP Trunk Test Account for this instance",
  "no_siptrunk_agreement_template": "No agreement template configured, please contact support",
  "missing_request_data_in_response": "Missing request data, please contact support",
  "missing_required_field_in_request_data": "A required field is missing from an internal request, please contact support",
  "account_verify_failed_headline": "Verification Failed",
  "account_verify_failed_content": "The data you entered does not comply with validation requirements.",
  "account_retry_signup": "Try again",
  "company_contact_logged_in_user_hint": "This is the logged in user. If you change the email address you need to relogin in mypascom.",
  "subscriptions_show_expired_with_counter": "Show expired ({{number}})",
  "mail_validation_invalid": "Mail is invalid. Please use a correct mail address.",
  "mail_validator_status_not_found": "Mail cannot be verified. Please try again later.",
  "mail_validation_error": "Mail cannot be verified. Please try again later.",
  "cancel_subscription": "Cancel Subscription",
  "cancel_subscription_warning_text": "Subscription will be cancelled",
  "cancel_subscription_headline": "Cancel Subscription [{{ applianceId }}] {{ applianceName }}",
  "cancel_subscription_cancel_endofsubscription": "Cancel at the end of subscription",
  "cancel_subscription_cancel_endofsubscription_description": "Your subscriptions end on {{ nextInvoice }}. The telephone system \"{{applianceName}}\" will work until {{ nextInvoice }}. Please create a backup up to this point if you want to keep your data.",
  "cancel_subscription_cancel_now": "Cancel FREE NOW",
  "cancel_subscription_cancel_endofsubscription_button": "Cancel on {{ nextInvoice }}",
  "cancel_subscription_abort": "Don't cancel!",
  "cancel_subscription_confirm_date_warning_text": "Cancel on {{ nextInvoice }}",
  "cancel_warning_deleted_immediately": "Your instance will be deleted IMMEDIATELY",
  "cancel_warning_loose_data": "You will loose all your data",
  "cancel_warning_remaining_terms_expires": "Any remaining terms expire now",
  "cancel_warning_subscription_cannot_open_again": "The subscription can not be opened again",
  "cancel_warning_no_calls_immediately": "You can not place calls IMMEDIATELY",
  "cancel_warning_noconnect_pascomclient_immediately": "You can not connect pascom Client IMMEDIATELY",
  "cancel_warning_deleted_after": "Yout instance will be deleted after {{ nextInvoice }}",
  "cancel_warning_loose_data_after": "You will loose all data after {{ nextInvoice }}",
  "cancel_warning_no_calls_after": "You can not place calls after {{nextInvoice }}",
  "cancel_warning_noconnect_pascomclient_after": "You can not connect pascom Client after {{nextInvoice }}",
  "warning_headline": "Warning",
  "instance_name_lowercase_hint": "Please use only lowercase for the name.",
  "sla_product_select": "Select",
  "MDSL1": "SLA1 (Included in subscription)",
  "MDSL2": "SLA2",
  "MDSL3": "SLA3",
  "MDSL1_description": "Included in our PREMIUM Subscription",
  "MDSL2_description": "You want the extra SAFETY",
  "MDSL3_description": "Communication is KEY for you",
  "missing_product": "Please select 'Concurrent Users' value",
  "subscription_sla": "SLA Option",
  "sla_product_feature_reaction_next_day": "Reaction Time\nNext Business Day",
  "sla_product_feature_reaction_4_hours": "Reaction Time\n4 hours",
  "sla_product_feature_reaction_2_hours": "Reaction Time\n2 hours",
  "sla_product_feature_support_sla1": "Support Hours\nMo-Fr, 09:00-17:00\n(Public Holidays excluded)",
  "sla_product_feature_support_sla2": "Support Hours\nMo-Fr, 08:00-18:00\n(Public Holidays excluded)",
  "sla_product_feature_support_sla3": "Support Hours\nEveryday, 08:00-20:00",
  "current_licenses": "You have {{ users }} licenses",
  "current_sla": "You have {{ sla }}",
  "subscription_change_host": "Change host",
  "subscription_change_host_headline": "Change host for Subscription [{{ applianceId }}] {{ applianceName }}",
  "subscription_change_host_warning_header": "Subscription host will be changed",
  "subscription_change_host_warning_text": "The telephony system \"{{applianceName}}\" will stop working on the current host.\nPlease be sure that you have already created a backup so that you can restore your phone system from this backup on the new host.",
  "subscription_change_host_abort": "Don't change!",
  "subscription_change_host_continue": "Continue",
  "subscription_change_host_confirm_headline": "Change host for Subscription [{{ applianceId }}] {{ applianceName }}",
  "subscription_change_host_confirm_warning_header": "Subscription host will be changed from \"{{currentHostName}}\" to  \"{{newHostName}}\"",
  "subscription_change_host_confirm_text": "The telephony system \"{{applianceName}}\" will stop working IMMEDIATELY on the current host \"{{currentHostName}}\"!\nPlease be sure that you have already created a backup so that you can restore your phone system from this backup on the new host \"{{newHostName}}\".",
  "subscription_change_host_confirm_label": "Confirm host change",
  "subscription_change_host_confirm_abort": "Don't change!",
  "subscription_change_host_confirm_button": "Confirm",
  "subscription_change_host_done_headline": "Changed host for Subscription [{{ applianceId }}] {{ applianceName }}",
  "subscription_change_host_done_warning_header": "Subscription host is now \"{{newHostName}}\"",
  "subscription_change_host_done_label": "Success! Please update your subscription(s)",
  "subscription_change_host_done_text": "To complete your subscription host changes, please go to the management UI and update the subscription in the \"System > Update subscription\".\n\nHost(s):",
  "subscription_change_host_done_host": "<br><a href=\"https://{{hostName}}:8443/ui/system\" target=\"_blank\">https://{{hostName}}:8443/ui/system</a>",
  "subscription_change_host_done_button": "OK",
  "subscription_not_found": "Subscription not found",
  "workflow_management_password_reset_button": "Reset password",
  "workflow_management_password_reset_error": "Cannot create management password reset token. Reason: {{ error }}",
  "invalid_request_token": "Invalid request token",
  "workflow_management_password_reset_headline": "Management password reset",
  "support_ticket_list_headline": "My Support Tickets",
  "support_ticket_add_button": "New Ticket",
  "support_ticket_list_show_new_tickets": "New",
  "support_ticket_list_show_closed_tickets": "Closed",
  "support_ticket_list_show_my_tickets": "Show only created by me",
  "support_ticket_list_show_open_tickets": "Open",
  "support_ticket_list_show_pending_closed_tickets": "Pending closed",
  "support_ticket_list_show_pending_reminder_tickets": "Pending reminder",
  "support_dropdown_filter_states": "Filter states",
  "support_ticket_number": "Ticket#",
  "support_ticket_created": "Created:",
  "support_ticket_closed": "Closed:",
  "support_ticket_search_placeholder": "Search tickets...",
  "support_ticket_close": "Close ticket",
  "support_ticket_created_by": "Created by:",
  "support_ticket_state": "State:",
  "support_ticket_subscription": "Subscription:",
  "support_ticket_view_subscription": "Open Subscription",
  "app_reply": "Reply",
  "app_select": "Select",
  "app_submit": "Submit",
  "support_select_subscription": "Select a subscription",
  "support_select_subscription_hint": "Select a subscription with pascom Support or upgrade one accordingly.",
  "support_new_ticket_headline": "New Ticket for Subscription {{ subscriptionName }}",
  "support_ticket_form_subject_label": "Subject",
  "support_ticket_form_description_label": "Please describe your issue",
  "support_ticket_load_more_button": "Load more",
  "support_article_attached_files": "{{ attachedFiles }} Attached files",
  "support_upgrade_to_premium": "Upgrade",
  "app_file_upload": "Upload a file",
  "app_upload": "Upload",
  "app_upload_attachment": "Select attachments",
  "support_attachment_error_tomanyfiles_summary": "Only {{ maxLength }} files for upload are allowed",
  "support_attachment_error_tomanyfiles_detail": "Please choose maximal {{ maxLength }} files for this upload. It is possible to choose a archive for the upload.",
  "support_attachment_error_tobigfile_summary": "File is to big for the upload",
  "support_attachment_error_tobigfile_detail": "The file {{ filename }} is to big for this upload. The max file size is {{ maxSize }}.",
  "support_attachment_file_info": "Please choose max {{ maxLength }} files and {{ maxSize }} each for the upload",
  "app_cancel": "Cancel",
  "support_ticket_close_confirm": "Yes, close this ticket",
  "support_ticket_close_headline": "Close ticket #{{ticketNumber}}",
  "support_ticket_close_description": "This ticket will be closed after confirmation. You will get an overview of this ticket by displaying all closed tickets.",
  "cannot_get_ticket": "No ticket was found.",
  "support_attachment_warn_tomanyfilesselected_summary": "Only {{ maxLength }} files for upload are allowed",
  "support_attachment_warn_tomanyfilesselected_detail": "You tried to upload more than {{ maxLength }}. We uploaded the first {{ maxLength }}. It is possible to upload archives with more than 3 files.",
  "support_state_new": "New",
  "support_state_closed": "Closed",
  "support_state_open": "Open",
  "support_state_pending_reminder": "Pending Reminder",
  "support_state_pending_close": "Pending Close",
  "germany_vat_hint_change_2020": "Note on lowering VAT in Germany:<br><br>If the end of the contract period falls after December 31, 2020, 19% sales tax will still be charged.<br>This applies in particular to our software annual subscriptions.",
  "navigation_trunks": "Trunks",
  "trunk_block_referencenumber": "Reference number",
  "trunk_block_phonenumber_count": "phone number(s)",
  "company_choose_headline": "Company",
  "company_choose_details_headline": "You are not in a company",
  "company_choose_details_description": "Please choose one of this options to create a new or add your user to an existing company.",
  "company_choose_new_btn": "Create new company",
  "company_choose_existing_btn": "Add my user to existing company",
  "company_choose_existing_headline": "Company Invitation",
  "company_choose_existing_text": "Please <b>ask your my.pascom.net admin</b> to invite you to your company. You will get an <b>invitation email with further instructions.</b>",
  "company_choose_new_company_headline": "Create a new company",
  "company_choose_new_company_save_btn": "Save",
  "2fa_sms_headline": "Two Factor Authentication",
  "2fa_sms_code_label": "Verification code",
  "2fa_sms_send_btn": "Verify",
  "2fa_sms_resend_btn": "Send verification code again",
  "2fa_sms_step_info": "We sent you a verification code to:<div class='phonenumber'>{{number}}</div>Please check your SMS for the code.",
  "order_load_more_button": "Load more",
  "navigation_quotations": "Quotations",
  "navigation_orders": "Orders",
  "navigation_invoices": "Invoices",
  "navigation_phonenumbers": "Phonenumbers",
  "search_orders": "Search orders...",
  "no_orders": "No orders",
  "auth_update_phone_number_btn": "Update two-factor mobile number",
  "auth_update_password_btn": "Update password",
  "update_phone_number_confirm_title": "Update two-factor mobile number",
  "update_phone_number_confirm_message": "You will receive an email with instruction to change your mobile number.",
  "update_user_confirm_title": "Update E-mail address",
  "update_user_confirm_message": "You need to login again!",
  "phonenumber_add_button": "Add Phonenumber",
  "phonenumber_search_placeholder": "Search phonenumber",
  "phonenumber_list_headline": "Phonenumbers",
  "start": "Start",
  "end": "End",
  "length": "Length",
  "phonenumber": "Number",
  "phonenumbers": "Numbers",
  "phonenumber_type_block": "Numberblock",
  "phonenumber_type_single": "Single Number",
  "location_independent_label": "(Location independent)",
  "trunk_status_pending": "pending",
  "trunk_status_pending_description": "The actual status is pending.",
  "trunk_status_active": "active",
  "trunk_status_active_description": "The actual status is active.",
  "trunk_status_dead": "dead",
  "trunk_status_dead_description": "The actual status is dead.",
  "maintenance_scheduled_headline": "Scheduled maintenance",
  "maintenance_scheduled_description": "Our services are on scheduled maintenance at the moment. Please try again later.",
  "cancel_csp_warning_text": "Are your sure to cancel this CSP now?",
  "pascom_one_product_name": "pascom ONE",
  "pascom_one_trial_product_name": "pascom ONE Trial",
  "pascom_one_product_description": "All-In no headache!",
  "pascom_one_billing_period_text": "Concurrent User/Month",
  "pascom_one_feature_type": "Cloud only",
  "pascom_one_feature_payment": "Monthly payment",
  "pascom_one_feature_users": "Single Users Available (No Packages)",
  "pascom_one_feature_trunking": "Trunking included",
  "pascom_one_price_landline_de": "0,9 Cent/Min German Landline",
  "pascom_one_price_mobile_de": "9,9 Cent/Min German Mobile network",
  "pascom_one_price_landline_at": "1,9 Cent/Min Austrian Landline",
  "pascom_one_price_mobile_at": "6,9 Cent/Min Austrian Mobile network",
  "pascom_one_price_landline_ch": "CHF 0.03 per minute to the Swiss landline network",
  "pascom_one_price_mobile_ch": "CHF 0.24 per minute to the Swiss mobile network",
  "start_one_trial_button": "Start a FREE 30 day trial",
  "pascom_classic_product_name": "pascom Classic",
  "pascom_classic_product_description": "Starts at",
  "pascom_classic_billing_period_text": "per Year",
  "pascom_classic_feature_type": "Cloud or Onsite",
  "pascom_classic_feature_payment": "Yearly Payment",
  "pascom_classic_feature_users": "Users Package Only (4, 8, 16, 32, ...)",
  "recommended_product": "Recommended",
  "app_or": "Or",
  "app_create_button": "Create",
  "contact_name_label": "Name",
  "select_contact_select_or_create": "Select or Create new Contact for {{companyName}}",
  "contact_select_or_create_hint": "The contact you select here will be invited to my.pascom.net. He can manage payments, upgrade the subscription and buy phonenumbers.",
  "test_phonenumber_headline": "Test Phonennumber",
  "test_phonenumber_headline_hint": "Test Phonennumber",
  "test_phonenumber_hint_at": "You get a FREE test phone number with 100min credits valid for Austrian landline and mobile networks.",
  "test_phonenumber_hint_de": "You get a FREE test phone number with 100min credits valid for German landline and mobile networks.",
  "test_phonenumber_hint_ch": "You get a FREE test phone number with 100min credits valid for Swiss landline and mobile networks.",
  "your_phonenumber_text": "Your phonenumber:",
  "test_phonenumber_accept_terms_at": "I understood, that I can only call Austrian landline and mobile numbers.",
  "test_phonenumber_accept_terms_de": "I understood, that I can only call German landline and mobile numbers.",
  "test_phonenumber_accept_terms_ch": "I understood, that I can only call Swiss landline and mobile numbers.",
  "company_address_headline": "Company Address",
  "company_address_hint": "You will get a phonenumber for testing purposes. Because of the regulatory authority, we are obliged to record the location of your company",
  "company_address_accept_terms": "I hereby confirm the correctness of the address given",
  "company_address_street_label": "Street",
  "company_address_zip_label": "ZIP",
  "company_address_city_label": "City",
  "pascom_one_trial_days_left": "Trial - {{daysLeft}} day(s) left",
  "phonenumber_check_reservation_status_headline": "Phone number reservation",
  "phonenumber_check_reservation_status_description": "We are reserving a phone number for you at the moment.",
  "no_more_trial_allowed": "Sorry, but you are not allowed to have more than *one* pascom ONE *trial* subscription",
  "maintenance_scheduled_status_page_link_text": "Open pascom status page",
  "nav_customer_contacts": "Contacts",
  "nav_customer_details": "Details",
  "nav_customer_subscriptions": "Subscriptions",
  "customer_contact_search": "Search contact...",
  "upgrade_one_select_cu": "Select Concurrent Users",
  "upgrade_one_what_is_cu": "<a href=\"https://www.pascom.net/en/voip-prices/#benefits\" target=\"_blank\">What is a Concurrent User?</a>",
  "upgrade_one_billing_info": "per Month ({{cuPrice}}/Concurrent User)",
  "upgrade_one_price_trunklines": "Trunk Lines",
  "upgrade_one_price_endpoints": "Endpoints",
  "upgrade_one_price_phonenumbers": "Trunk Phonenumbers",
  "upgrade_one_cu_error_min": "You cannot set Concurrent Users lower than {{cuMin}}.",
  "upgrade_one_cu_error_max": "You cannot set Concurrent Users higher than {{cuMax}}.",
  "PC-ONE-SLA1": "SLA1 (Included in subscription)",
  "PC-ONE-SLA1_label": "SLA1",
  "PC-ONE-SLA2": "SLA2",
  "PC-ONE-SLA2_label": "SLA2",
  "PC-ONE-SLA3": "SLA3",
  "PC-ONE-SLA3_label": "SLA3",
  "PC-ONE-SLA1_description": "Included in our pascom ONE Subscription",
  "PC-ONE-SLA2_description": "You want the extra SAFETY",
  "PC-ONE-SLA3_description": "Communication is KEY for you",
  "sla_product_selected": "Your SLA",
  "sla_product_upgrade": "Upgrade",
  "price_per_month": "per Month",
  "product_no_upgrade_option_selected": "No upgrade option selected",
  "product_no_upgrade_option_selected_description": "You need to add more Concurrent Users or/and select a SLA Product upgrade.",
  "phonenumbers_type_new": "New Phonenumbers",
  "phonenumbers_type_new_button": "Add new phonenumbers",
  "phonenumbers_type_port": "Port Existing Phonenumbers",
  "phonenumbers_type_port_button": "Port existing phonenumbers",
  "phonenumbers_type_loc_independent": "Location Independent Number",
  "phonenumbers_type_loc_independent_button": "Add new location independent number",
  "phonenumbers_type_loc_independent_hint": "Order a location-independent phone number that is not tied to the location of your company.",
  "phonenumbers_currently_in_use_subscription": "Currently in use",
  "phonenumbers_type_new_hint": "Simply order new phone numbers using our step-by-step process. These numbers are regionally tied to the location of your company.",
  "phonenumbers_type_port_hint": "If you want to port your existing phone numbers to pascom, that's no problem. Benefit from a one-stop solution. We place a porting order for you to your existing provider and transfer your existing numbers to pascom.",
  "phonenumber_select_blocksize": "Select Phonenumber Blocksize",
  "phonenumber_type_headline": "Add phonenumber",
  "phonenumbers_type_disclaimer": "If you need more phone numbers than included in your subscription, the one-time setup fee is {{setupPrice}} per number and monthly costs are {{monthlyPrice}} per number",
  "phonenumber_blocksize_hint": "You can select up to {{count}} phonenumbers with a blocksize of {{ blockSize }} each, on the next step.",
  "phonenumber_selected_numbers": "Your selected Phonenumbers ({{selected}}/{{max}})",
  "checkout_summary_monthly_payments": "Monthly Payments",
  "checkout_summary_onetime_setup_fee": "Onetime Setup Fee",
  "checkout_summary_fixed_monthly_payments": "Fixed Monthly Payments",
  "checkout_summary_dynamic_monthly_payments": "Dynamic Monthly Payments",
  "checkout_summary_monthly_phone_charges": "Monthly phone charges",
  "checkout_summary_download_pricelist": "Download Pricelist",
  "checkout_summary_download_pricelist_link": "https://www.pascom.net/wp-content/uploads/pricelist-{{language}}.pdf",
  "checkout_summary_download_country_pricelist": "Monthly phone charges <a href=\"https://www.pascom.net/wp-content/uploads/pricelist-en{{country}}.pdf\" target=\"_blank\">Pricelist download</a>",
  "checkout_summary_monthly_renewed": "All subscriptions are automatically renewed if they are not explicitly canceled.",
  "checkout_summary_monthly_total": "Monthly Total",
  "subscription_type_cloud": "Cloud",
  "file_uploader_file_upload_hint_plural": "Please choose max {{ count }} files and {{ maxSize }} for each upload",
  "file_uploader_file_upload_hint": "Please choose one file with max size of {{ maxSize }} for the upload.",
  "file_uploader_file_upload_allowed_type_hint": "Allowed file types: {{ allowedFileTypes }}.",
  "file_uploader_to_many_files_error_headline_plural": "Only {{ count }} files for upload are allowed",
  "file_uploader_to_many_files_error_description_plural": "Please choose maximal {{ count }} files for this upload. It is possible to choose a archive for the upload.",
  "file_uploader_to_many_files_error_description_no_archive_plural": "Please choose maximal {{ count }} files for this upload.",
  "file_uploader_to_many_files_error_headline": "Only one file for upload are allowed",
  "file_uploader_to_many_files_error_description": "Please choose maximal one file for this upload.",
  "file_uploader_filesize_error_headline": "File is to big for the upload",
  "file_uploader_filesize_error_description": "The file {{ filename }} is to big for this upload. The max file size is {{ maxSize }}.",
  "file-uploader_filename_error_headline": "Invalid Name",
  "file-uploader_filename_error_description": "The file {{ filename }} has an invalid name for this upload. Please rename it and avoid special characters.",
  "file_uploader_filetype_error_headline": "File has incorrect type for the upload",
  "file_uploader_filetype_error_description": "The file {{ filename }} has incorrect type for this upload. Please upload file with type {{ allowed }}.",
  "file_uploader_attached_files_headline": "Attached files for upload:",
  "file_uploader_choose": "Click and select file",
  "file_uploader_choose_plural": "Click an select files",
  "file_uploader_upload": "Upload",
  "file_uploader_remove": "Remove",
  "file_uploader_upload_continue": "Upload and continue",
  "upload_company_license_headline": "Upload Company Location Confirmation",
  "upload_company_license_phone_bill_hint": "Current Phone Bill",
  "upload_company_license_register_hint": "Commercial Register Extract",
  "upload_company_license_continue_hint": "Choose a file and click on upload to continue.",
  "checkout_phonenumber_summary_monthly_payments": "Monthly Payment",
  "checkout_phonenumber_summary_onetime_setup_fee": "Onetime Setup Fee",
  "checkout_phonenumber_included_phonenumber": "Included in Subscription",
  "checkout_phonenumber_addtional_phonenumber": "Additional Phonenumber",
  "cannot_create_ticket": "Cannot create ticket",
  "reset_password_password_error_minLength": "The password needs to have at least 8 characters",
  "file_uploader_drag_select": "Drag & drop file here",
  "thank_you_buy_phonenumber_headline": "Thank you!",
  "thank_you_buy_phonenumber_content": "You added more phonenumbers to the subscription. At phonenumbers page you will get more details about the phonenumber status.",
  "thank_you_buy_phonenumber_back_button": "Back to phonenumbers overview",
  "cancel_pascom_one_headline": "Cancel Subscription [{{ applianceId }}] {{ applianceName }}",
  "cancel_pascom_one_card_headline": "Cancel at the end of subscription",
  "cancel_pascom_one_card_description": "After confirm the cancellation your subscription will end on {{ date }}. The telephone system \"{{applianceName}}\" will work until {{ date }}. Please create a backup up to this point if you want to keep your data.",
  "cancel_pascom_one_button": "Cancel on {{ date }}",
  "cancel_pascom_one_abort_button": "Don't cancel!",
  "pascom_one_expires_on": "Expires on:",
  "pascom_one_expired_on": "Expired on:",
  "cancel_one_warning_phonenumbers": "You will loose all your pascom phone number after {{ date }}. Be sure to port your needed phone numbers.",
  "no_phonenumbers": "Currently you don't have any phonenumber",
  "costumer_created": "Costumer {{name}} created.",
  "pascom_one_cannot_find_company_error": "Cannot find selected company.",
  "pc_credit": "Credit",
  "pc_credit_hint": "You have a credit of {{credit}}. The credit is automatically deducted from future monthly bills until the credit is completely used up.",
  "checkout_summary_pc_credit_text": "With this order, you will receive {{credit}} credit. You will receive this proportionally from the booked users, as the billing takes place retrospectively on a monthly basis, and you do not use our product from the first day of the month.",
  "checkout_summary_credit_migration_text": "You will receive {{credit}} credit proportionally from the yearly paid bill.",
  "checkout_summary_pc_credit_general_text": "The credit will automatically be deducted from future monthly bills until it is completely used up.",
  "pc_one_sla_feature_reaction_next_day": "Reaction Time\nNext Business Day",
  "pc_one_sla_feature_reaction_4_hours": "Reaction Time\n4 hours",
  "pc_one_sla_feature_reaction_2_hours": "Reaction Time\n2 hours",
  "pc_one_sla_feature_support_sla1": "Support Hours\nMo-Fr, 09:00-17:00\n(Public Holidays excluded)",
  "pc_one_sla_feature_support_sla2": "Support Hours\nMo-Fr, 08:00-18:00\n(Public Holidays excluded)",
  "pc_one_sla_feature_support_sla3": "Support Hours\nEveryday, 08:00-20:00",
  "pcone_details_itemized_billing": "Itemized Billing",
  "pcone_details_itemized_billing_invoice_only_text": "Itemized billing is currently disabled.",
  "pcone_details_itemized_billing_invoice_anonymize_text": "Itemized billing is active and contains anonymize data",
  "pcone_details_itemized_billing_invoice_full_text": "Itemized billing is active and contains full data",
  "pcone_details_update_itemized_billing_button": "Change settings",
  "itemized_billing_settings_headline": "Itemized Billing",
  "itemized_billing_settings_hint": "By activating itemized billing you confirm that all employees have been or will be informed about this and that the works council or the staff or employee representatives were involved in accordance with the statutory provisions.",
  "itemized_billing_card_invoice_only_headline": "Invoice Only",
  "itemized_billing_card_anonymize_headline": "Anonymize",
  "itemized_billing_card_full_headline": "Full",
  "itemized_billing_card_invoice_only_text": "You will <b>NOT</b> receive an itemized statement with your monthly invoice.",
  "itemized_billing_card_anonymize_text": "You will receive an itemized statement with your monthly invoice but the last three digits of destination phone number will be <b>anonymized</b> and replaced with X-signs.",
  "itemized_billing_card_full_text": "You will receive an itemized statement with your monthly invoice with <b>full</b> destination phone numbers.",
  "account_data_protection": "Read about our <a href=\"https://www.pascom.net/en/data-protection/\" target=\"_blank\">Data Protection</a>.",
  "vat_not_included": "* All prices are net plus VAT.",
  "select_classic_product": "Open classic products",
  "pascom_one_deleting_hint": "** Runs for 30 days. This test system will be automatically deleted afterwards, unless a contract is concluded.",
  "summary_services_description": "Click on <a href=\"https://www.pascom.net/en/\" target=\"_blank\">Description of services</a> for more information.",
  "summary_services_country_description": "Further information can be found in our <a href=\"https://www.pascom.net/wp-content/uploads/description-of-service-pascom-one-en{{country}}.pdf\" target=\"_blank\"> description of services</a>.",
  "checkout_one_summary_accept_terms": "I hereby accept pascom's <a href=\"https://www.pascom.net/terms-and-conditions\" target=\"_blank\">Terms and Conditions</a>",
  "checkout_one_summary_country_accept_terms": "I hereby accept the <a href=\"https://www.pascom.net/wp-content/uploads/gtc-pascom-one-en{{country}}.pdf\" target=\"_blank\"> terms and conditions of pascom ONE </a> and sign the <a href = \"https://www.pascom.net/wp-content/uploads/order-processing-contract-pascom-one-en{{country}}.pdf\" target = \"_ blank\">Contract for order processing</a> according to GDPR.",
  "phonenumber_port_coming_soon_text": "Porting a phone number is <b>not activated</b> yet. We are working hard on this feature, and it will <b>come soon</b>.",
  "no_license": "Subscription not found.",
  "phonenumber_port_prepare_headline": "Please prepare the following",
  "prepare_phonenumbers": "1. Phonenumbers",
  "prepare_phonenumbers_text": "You need to know <b>exactly</b> which phonenumers you want to port. Including information about <b>area code</b>, <b>main number</b>, <b>extensions</b> (if any), etc. ",
  "prepare_latest_phonebill": "2. Latest Phonebill",
  "prepare_latest_phonebill_text": "A <b>scan</b> or <b>file</b> of our latest <b>phonebill</b> in <b>PDF</b> format.",
  "prepare_sign_pdf": "3. Ability to Sign a PDF",
  "prepare_sign_pdf_text": "You will have to add your <b>signature</b> and <b>company stamp</b> to a PDF from. Your need a printer/scanner or your signature and company stamp ready to use in your favorite PDF editor.",
  "phonenumber_to_port_headline": "Numbers to Port",
  "port_number_areacode_placeholder": "Area Code e.g. 030",
  "port_number_mainnumber_placeholder": "Main Number e.g. 12345",
  "port_number_blockstart_placeholder": "Block Start e.g. 00",
  "port_number_blockend_placeholder": "Block End e.g. 99",
  "port_number_phonenumber_placeholder": "Number",
  "port_number_areaCode_error_required": "Area Code is required. E.g. 030",
  "port_number_mainNumber_error_required": "Main Number is required. E.g. 12345",
  "port_number_blockStart_error_required": "Block Start is required. E.g. 00",
  "port_number_blockEnd_error_required": "Block End is required. E.g. 99",
  "port_number_number_error_required": "Number is required.",
  "port_number_provider_error_required": "Provider is required.",
  "port_number_single_example_headline": "Example",
  "port_number_block_example_headline": "Example",
  "port_number_single_example_text": "Your company number is +49 89 153326 <br><br>Area Code: <b>089</b>, Number: <b>153326</b>",
  "port_single_number_example_a_headline": "Example",
  "port_single_number_example_a_text": "Your company have a single number +49 991 29691:<br><br>Area Code: <b>0991</b>, Number: <b>29691</b>.",
  "port_number_example_a_headline": "Example 1",
  "port_number_example_a_text": "Your company number is +49 991 29691 0 and you have one digit extensions from 0 to 9:<br><br>Area Code: <b>0991</b>, Main Number: <b>29691</b><br>Block Start: <b>0</b>, Block End: <b>9</b>",
  "port_number_example_b_headline": "Example 2",
  "port_number_example_b_text": "Your company number is +49 991 29691 0 and you have two digit extensions from 0 to 29:<br><br>Area Code: <b>0991</b>, Main Number: <b>29691</b><br>Block Start: <b>00</b>, Block End: <b>29</b>",
  "port_number_example_c_headline": "Example 3",
  "port_number_example_c_text": "Your company number is +49 991 29691 0 and you have three digit extensions from 0 to 999:<br><br>Area Code: <b>0991</b>, Main Number: <b>29691</b><br>Block Start: <b>000</b>, Block End: <b>999</b>",
  "port_number_already_selected_error_title": "Your selected phone number is already existing",
  "port_number_already_selected_error_description": "Your selected phone number is already existing in your list. You can continue with another number.",
  "port_number_max_selected_error_title": "Only {{ max }} numbers selectable",
  "port_number_max_selected_error_description": "You selected only select up to {{ max }} single phone numbers to port.",
  "number_already_taken_and_not_dead": "The selected phone number is already in use at pascom or is part of an ongoing order",
  "number_already_taken_and_not_dead_plural": "The selected phone numbers are already in use at pascom or are part of an ongoing order",
  "port_number_add_single_number": "Add a phone number",
  "port_number_add_block_number": "Phone number block",
  "port_number_add_single_number_button": "Add phone number",
  "port_number_add_single_number_list": "Phone numbers list",
  "download_port_form_headline": "Download and sign porting form",
  "download_port_form_text": "We have prepared a porting form for you. Please <b>download</b> it and add your <b>signature</b> and <b>company stamp</b>. You can upload the document again in the next step.",
  "download_port_form_link": "#",
  "app_download": "Download",
  "upload_port_form_headline": "Upload Porting Form",
  "upload_port_phonebill_headline": "Upload Latest Phonebill",
  "port_number_previewFrom_label": "Your number block start preview",
  "port_number_previewTo_label": "Your number block end preview",
  "port_number_previewNumber_label": "Your number preview",
  "port_number_areaCode_error_pattern": "Please enter only digits for area code",
  "port_number_mainNumber_error_pattern": "Please enter only digits for main number",
  "port_number_blockStart_error_pattern": "Please enter only digits for block start",
  "port_number_blockEnd_error_pattern": "Please enter only digits for block end",
  "port_number_countryPrefix_label": "Country Prefix",
  "port_number_areaCode_label": "Area Code",
  "port_number_mainNumber_label": "Main number",
  "port_number_blockStart_label": "Block Start",
  "port_number_blockEnd_label": "Block End",
  "port_number_number_label": "Number",
  "port_number_type_label": "Number Type",
  "port_number_blockEnd_error_compareNumber": "Block End must be greater than Block Start",
  "port_number_blockStart_error_maxlength": "Please enter a maximum of 3 digits.",
  "port_number_blockEnd_error_maxlength": "Please enter a maximum of 3 digits.",
  "port_number_areaCode_error_maxlength": "Please enter a maximum if 6 digits for the Area Code.",
  "manage_phonenumber_later": "We could not reserve your test phone number. You can try again later in the myPASCOM phone number management.",
  "navigation_legal_notice": "Legal Notice",
  "navigation_data_protection": "Data Protection",
  "port_number_provider_label": "Old Provider",
  "port_number_provider_error": "Provider is required.",
  "port_number_provider_placeholder": "Provider e.g. Telekom Deutschland GmbH",
  "no_one_subscriptions": "You don't have a matching pascom one subscription.",
  "port_number_number_error_pattern": "Please enter only digits for number",
  "phonenumber_bill_check_company_name": "Enter same company name on uploaded phone bill",
  "phonenumber_bill_check_company_name_warning": "Please check and enter the same company name on your phone bill.",
  "phonenumber_prepare_port_form_custom_address_headline": "Alternative address for porting form",
  "phonenumber_prepare_port_form_custom_address_hint": "If your company has multiple locations, you can specify a different address for the port form. This allows you to use an alternative location address instead of your main company address.",
  "phonenumber_prepare_port_form_show_custom_address_btn": "Use custom address",
  "phonenumber_prepae_port_form_data": "Additional data for the porting form",
  "authentication_failed_headline": "Authentication failed",
  "authentication_failed_description": "The authentication failed. We will try to do this again in a few seconds, or press on retry button to do it manually.",
  "authentication_failed_retry_button": "Try again",
  "address_validation_failed": "Address validation is currently not working. Please contact sales@pascom.net if the issue persists.",
  "order_trial_phonenumber_checkbox_text": "Yes, I want a trial phone number",
  "order_trial_phonenumber_headline": "pascom ONE trial phone number",
  "order_trial_phonenumber_box_headline": "Do you want a pascom ONE trial phone number?",
  "order_trial_phonenumber_continue_btn": "Yes, continue",
  "order_trial_phonenumber_skip_btn": "No, proceed without",
  "order_trial_phonenumber_description_at": "During the trial period you have the possibility to use a <b>call credit of 100 Minutes</b> for outgoing calls. Outgoing calls are limited to national landline and mobile calls in Austria. Once the call credit has been used up, no further outgoing calls are possible. In this case, you can <b>upgrade your pascom cloud trial subscription.</b>",
  "order_trial_phonenumber_description_de": "During the trial period you have the possibility to use a <b>call credit of 100 Minutes</b> for outgoing calls. Outgoing calls are limited to national landline and mobile calls in Germany. Once the call credit has been used up, no further outgoing calls are possible. In this case, you can <b>upgrade your pascom cloud trial subscription.</b>",
  "order_trial_phonenumber_description_ch": "During the trial period you have the possibility to use a <b>call credit of 100 Minutes</b> for outgoing calls. Outgoing calls are limited to national landline and mobile calls in Switzerland. Once the call credit has been used up, no further outgoing calls are possible. In this case, you can <b>upgrade your pascom cloud trial subscription.</b>",
  "remove_phone_number_confirm_title": "Cancel phone number",
  "remove_phone_number_confirm_message": "Do you really want to cancel this phone number?",
  "invalid_block_id": "The given phone numbers block id is invalid",
  "not_owner_of_this_number": "You are not the owner of this phone number",
  "block_has_no_numbers": "This phone number block has no numbers",
  "numbers_dont_have_subscription": "This numbers has no subscription.",
  "block_has_no_from_number_id": "Phone number block has no from number",
  "invite_title": "Invite accepted",
  "invite_salutation": "Hello",
  "invite_description": "<b>We sent you an email</b> to setup a password and complete this step. <b>Please follow the instructions in the email</b>. You can close this page.",
  "invite_done_button": "Done!",
  "upload_allowed_type_images": "image files",
  "upload_allowed_type_audios": "audio files",
  "upload_allowed_type_videos": "video files",
  "phonenumbers_type_summary": "You are using {{ currentlyInUse }} out of {{ includedInSubscription }} <b>included for free</b> in your subscription",
  "port_select_block_size_headline": "Choose phone number size to port",
  "port_select_single_number_headline": "Port up to 10 single numbers",
  "port_select_single_number_text": "On the next step you can port up to <b>10 single phone numbers</b> within the same area code.",
  "port_select_single_number_button": "Proceed with single phone numbers",
  "port_select_block_headline": "Port phone number block",
  "port_select_block_text": "On the next step you can choose an block of phone numbers. You will have area code, main phone number and digit extensions.",
  "port_select_block_button": "Proceed with phone number block",
  "port_old_provider_headline": "Port from provider",
  "port_old_provider_number_headline": "Port from your provider",
  "port_old_provider_number_text": "Type the provider name you came from to port to pascom. If you cannot find your provider name on the list, type the name specified on your phone bill.",
  "change_password_confirm_message": "Because of security reasons, you may need to re-login before you can change your password.",
  "cloud_status_operational": "pascom Cloud Operating Normally",
  "cloud_status_degraded": "pascom Cloud Experiencing Degraded Service",
  "cloud_status_outage": "pascom Cloud Experiencing Downtime",
  "cloud_status_link_text": "Show details on status.pascom.net",
  "cloud_status_info_text": "Before opening a ticket, please check if your issue has nothing to do with an already known problem.",
  "undo_cancellation_subscription": "Undo cancellation",
  "undo_cancellation_subscription_confirm_header": "Undo cancellation?",
  "undo_cancellation_subscription_confirm_message": "You will undo the cancellation of your subscription.",
  "contact_email_error_email": "The email format is not correct.",
  "could_not_validate_customer_address": "The provided company address seems to be invalid. Please make sure you entered everything correctly. If this problem persists, please contact sales@pascom.net.",
  "tariff_flat_standard": "Standard",
  "current_tariff_text": "You are using \"{{ currentTariff }}\". You can change the tariff any time for the next billing period.",
  "ordered_tariff_text": "You are using \"{{ currentTariff }}\". You will change to \"{{ orderedTariff }}\" on {{date}}. You can change the tariff any time for the next billing period.",
  "tariff_standard": "standard tariff",
  "tariff_flat_s": "Fair Flat S",
  "tariff_flat_m": "Fair Flat M",
  "tariff_flat_l": "Fair Flat L",
  "tariff_flat_xl": "Fair Flat XL",
  "tariff_choose_headline": "Choose a Tariff",
  "tariff_including_minutes": "Including Minutes",
  "tariff_popular": "Popular",
  "download_complete_pricelist": "<a href=\"https://www.pascom.net/wp-content/uploads/pricelist-en{{tenant}}.pdf\" target=\"_blank\">Download Complete Pricelist</a>",
  "tariff_min_deu_fixed": "min German Landline",
  "tariff_min_deu_mobile": "min German Mobile Network",
  "tariff_min_aut_fixed": "min Austrian Landline",
  "tariff_min_aut_mobile": "min Austrian Mobile Network",
  "tariff_min_che_fixed": "min Swiss Landline",
  "tariff_min_che_mobile": "min Swiss Mobile Network",
  "telephone_tariff": "Telephone Tariff",
  "choose_tariff": "Choose Tariff",
  "tariff_cancel_order": "Cancel order",
  "tariff_headline_select_order": "Place Order",
  "tariff_summary": "Summary",
  "tariff_summary_info": "You are changing your tariff from \"{{ currentTariff }}\" to \"{{ selectedTariff }}\".",
  "tariff_select_start_date": "Select Start Date",
  "tariff_select_start_date_info": "Please select when you want to change the tariff. Only possible at the start if a month.",
  "product_currently_used": "Current Tariff",
  "thank_you_tariff_headline": "Tariff changed",
  "thank_you_tariff_content": "You successfully changed your tariff.",
  "thank_you_tariff_back_button": "Back to your subscription",
  "subscription_trunk_header": "Tariff settings",
  "chosen_current_same_tariff": "You chosen tariff is already your current",
  "chosen_current_same_tariff_details": "You chosen tariff is already your current selected tariff on your subscription. Please choose a different tariff.",
  "tariff_cancel_order_confirm_headline": "Cancel Order",
  "tariff_cancel_order_confirm_text": "You will cancel the current order if you proceed. You can change another tariff afterwards.",
  "tariff_cancel_order_confirm_btn": "Proceed with cancel",
  "instance_paused_due_to_payment_issues": "The instance is paused since {{ date }}. Please contact our sales team.",
  "pbx_instance_paused": "instance is paused",
  "pbx_instance_paused_tooltip": "Instance is temporary paused",
  "checkout_summary_create_customer_offer": "Send quotation to {{ email }}",
  "thank_you_partner_headline": "Quotation was sent to {{ email }}",
  "thank_you_partner_content": "We sent the quotation to your customer. The order will be processed when he accepts the quotation. You will be notified by email. You can see your the state of the quotation directly in my.pascom.net",
  "thank_you_partner_open_customers_orders": "Open Customer Orders",
  "error_offer_confirm": "Cannot confirm this offer",
  "thank_you_confirm_upgrade_one_headline": "Thank you!",
  "thank_you_confirm_upgrade_one_content": "Your subscription has been upgraded.",
  "thank_you_confirm_phonenumber_headline": "Thank you!",
  "thank_you_confirm_phonenumber_content": "You added more phonenumbers to the subscription.",
  "one_click_cloud_migration_headline": "Cloud Migration",
  "one_click_cloud_migration_discontinue_text": "Your {{type}} installation will be discontinued on {{date}}",
  "one_click_cloud_migration_button": "Migrate to the pascom Cloud",
  "one_click_cloud_migration_benefit_user": "<b>No User Packets (4,8,16,...)</b> Only pay for what you actually use",
  "one_click_cloud_migration_benefit_fair_migration": "<b>Fair Migration</b> We will credit you with the current remaining term",
  "one_click_cloud_migration_benefit_monthly_billing": "<b>Monthly Billing</b> Lower and regular bills",
  "one_click_cloud_migration_benefit_trunk": "<b>New Options</b> Use the pascom trunk without additional basic charge",
  "thank_you_confirm_tariff_headline": "Tariff changed",
  "thank_you_confirm_tariff_content": "You successfully changed your tariff.",
  "quotation_status_customer_approval": "Wait for customer approval",
  "resend_quotation": "Resend Quotation",
  "cancel_quotation": "Cancel Quotation",
  "quotation_status_expired": "Order expired",
  "quotation_status_active": "Ordered",
  "quotation_status_pending_approval": "Waiting for pascom approval",
  "order_phone_number_price_hint": "Quotations may contain dynamic calculated products. Examples are the credit you get because you buy pascom ONE not on the first day of a month, or surcharges you have to pay because you buy more phone numbers than included in your subscription. These products will be recalculated and displayed in real time during the checkout process, depending on the current date or amount of phone numbers you are currently using. Therefore, the quotation price may slightly differ from the order price.",
  "resend_quotation_success_headline": "Resending quotation successfully",
  "resend_quotation_success_text": "The quotation was successfully resend to the customer.",
  "cancel_quotation_success_headline": "Quotation successfully canceled",
  "cancel_quotation_success_text": "Quotation was canceled. The customer has no longer access to this quotation.",
  "partner_offer_not_existing_headline": "Offer not existing",
  "partner_offer_not_existing_content": "This offer is not existing. When you clicked on the link given in your Email, please contact your partner to get more information. You can close this page.",
  "one_click_change_tariff_headline": "pascom ONE Tariff Plan",
  "one_click_change_tariff_discontinue_text": "Your current plan will be discontinued on {{date}}",
  "one_click_change_tariff_button": "Change Tariff",
  "one_click_change_tariff_benefit_user": "<b>No User Packets (4,8,16,...)</b> Only pay for what you actually use",
  "one_click_change_tariff_benefit_fair_migration": "<b>Fair Migration</b> We will credit you with the current remaining term",
  "one_click_change_tariff_benefit_monthly_billing": "<b>Monthly Billing</b> Lower and regular bills",
  "one_click_change_tariff_benefit_trunk": "<b>New Options</b> Use the pascom trunk without additional basic charge",
  "one_click_change_tariff_benefit_easy": "<b>Easy</b> One click Upgrade with no downtime",
  "select_invoice_contact_headline": "Select contact",
  "select_invoice_contact_hint": "This selected contact will be the contact person for this offer. Quotations will be sent to the contacts email address.",
  "select_invoice_contact_send_invite": "Send invitation mail?",
  "select_invoice_choose_contact": "Choose existing contact from list",
  "select_invoice_add_contact": "Add new contact",
  "select_customer_hint": "This selected customer will be the recieving this offer. Quotations will be sent to the contacts email address.",
  "select_choose_customer": "Choose existing customer from list",
  "select_add_customer": "Add new customer",
  "app_empty_multiselect": "No results found",
  "select_invoice_add_contact_button": "Add new contact",
  "select_invoice_contact_select_existing_button": "Back to existing Contacts",
  "select_invoice_contact_create_next_button": "Create contact and next",
  "select_invoice_contact_select_button": "Select contact and next",
  "select_customer_add_button": "Add new customer",
  "select_customer_select_existing_button": "Back to existing customers",
  "select_customer_create_next_button": "Create customer and next",
  "select_customer_select_button": "Select customer and next",
  "show_expired_quotation": "Show expired quotation",
  "phonenumber_delivery_date": "Delivery date",
  "phonenumber_block_type": "Number block with {{ length }} numbers",
  "partner_offer_cancelled_headline": "Offer cancelled",
  "partner_offer_cancelled_content": "This offer was cancelled. When you clicked on the link given in your Email, please contact your partner to get more information. You can close this page.",
  "summary_payment_details": "All amounts are debited from account {{ iban }} automatically.",
  "summary_number_from": "Phone number from",
  "summary_number_to": "Phone number to",
  "summary_company_name": "Company Name",
  "upgrade_one_annual_cloud_fewer_cu_warning": "You selected less users than you are currently use. The system might not work like expected after the downgrade.",
  "pbx_bootstate_running": "Running",
  "pbx_bootstate_running_tooltip": "PBX instance is running normal",
  "pbx_bootstate_down": "Down",
  "pbx_bootstate_down_tooltip": "PBX instance not running",
  "pbx_bootstate_failed": "Failed",
  "pbx_bootstate_failed_tooltip": "PBX instance failed starting",
  "pbx_bootstate_restore": "Restore",
  "pbx_bootstate_restore_tooltip": "PBX instance is restoring",
  "pbx_bootstate_starting": "Starting",
  "pbx_bootstate_starting_tooltip": "PBX instance is starting",
  "pbx_bootstate_update": "Updating",
  "pbx_bootstate_update_tooltip": "PBX instance is updating",
  "pbx_bootstate_unknown": "Unknown",
  "pbx_bootstate_unknown_tooltip": "We cannot read the actual state of this PBX. This can have multiple reasons. Please try again later.",
  "select_cloud_domain_headline": "Choose Cloud Domain",
  "select_cloud_domain": "Choose existing Cloud Domain from the list",
  "select_cloud_domain_button": "Select Domain and next",
  "update_phone_number_email_sent": "We sent you an email with instruction to change your mobile number.",
  "phonenumber_select_port_date_headline": "Select preferred porting date",
  "phonenumber_select_port_date_text": "Please select your preferred date for porting your phonenumbers",
  "pbx_instance_running": "instance is running",
  "pbx_instance_running_tooltip": "Instance is currently running",
  "invalid_delivery_date_min_30_days": "You need to pick a date +30 days from now.",
  "app_next_with_date": "Next with {{date}}",
  "invalid_trading_license": "The trading license need to be a PDF file. Please check your selected file.",
  "migration_information_headline": "Migration information",
  "migration_checklist_headline": "Checklist",
  "migration_warn": "If you the migration of your onsite license today, it will stay valid for <b>30 days</b>, in which you have to move to the cloud",
  "before_continuing": "Before you continue please make sure:",
  "migration_compatibility": "The trunk you want to use is supported in the pascom.cloud. See <a href=\"https://www.pascom.net/doc/en/trunk-templates/\" target=\"_blank\">Compatibility List</a>",
  "migration_data_pc18": "Your onsite installation is at least pascom 18 if you want to migrate your existing data to the cloud",
  "migration_guideline": "You have read the cloud migration <a href=\"https://www.pascom.net/doc/en/first-steps/migration/\" target=\"_blank\">Guideline</a>",
  "migration_credit": "You have {{concurrentUser}} Concurrent Users and prepaid {{prepaid}} for the period from {{dateFrom}} till {{dateTill}}. If you change your Tariff today you will get a credit of {{credit}}. The credit will be deducted from your monthly bills until it is used up",
  "migration_credit_headline": "Credit",
  "cloud_migration_select_cu": "Select Concurrent Users (You currently have {{users}} Users)",
  "cancel_provider_connection_check": "Automatically cancel connection with the current provider",
  "cancel_provider_connection_headline": "Cancel provider connection",
  "cancel_provider_connection_hint": "This means that a separate cancellation with the previous provider is not necessary.<br><b>But be careful!</b> For example, with DSL combination products, this option can also lead to cancellation of the DSL connection with some providers. If in doubt, please ask your previous provider.",
  "cloud_migration_already_pcone_page_headline": "Already a pascom ONE cloud subscription",
  "cloud_migration_already_pcone_card_headline": "Your selected subscription is already a pascom ONE cloud subscription",
  "cloud_migration_already_pcone_card_text": "You have tried to upgrade an onsite or classic license to a pascom ONE cloud subscription. Your selected subscription is already a pascom ONE cloud subscription. If you want to upgrade your subscription, please go to my.pascom.net, or use the button below.",
  "cancel_phone_number": "Cancel phone number",
  "cancel_phone_number_confirm_button": "Yes, cancel phone number",
  "subscription_details_pcone_from_csui_text": "You have tried to access the details of your onsite subscription. However, your subscription is already a pascom ONE. You can conveniently retrieve your data in the my.pascom.net portal, or use the button below to go there directly.",
  "instance_name_input_placeholder": "Enter your instance name",
  "company_contacts_add": "Add contact",
  "contact_add_header": "Add new contact",
  "app_add": "Add",
  "already_in_same_company": "The provided e-mail already exists",
  "already_in_another_company": "The provided e-mail already exists",
  "partner_create_nfr_one_btn": "Start New NFR Subscription",
  "cannot_create_nfr_one_error_headline": "Cannot create NFR ONE",
  "cannot_create_nfr_one_error_content": "It is not possible to create an NFR ONE subscription. This is the case if you already have an NFR ONE subscription or a trial that has not been upgraded.",
  "nfr_one_prepare_headline": "How NFR ONE Subscriptions Work",
  "nfr_one_create_trial_headline": "Create Trial",
  "nfr_one_create_trial_content": "First create a pascom ONE Trial for your company.",
  "nfr_one_upgrade_headline": "Upgrade",
  "nfr_one_upgrade_content": "Upgrade the pascom ONE Trial to your needs. You can also add or port phone numbers (only with german company address).<br><br>The checkout will show you end customer prices. You will get your credit later.",
  "nfr_one_credit_headline": "Get Credit",
  "nfr_one_credit_content": "Every month you will get automatically a credit for up to {{cu}} concurrent user as {{partnerLevel}} Partner.<br><br>You will also get partner commissions on your own phone charges and concurrent users that are not covered by your current partner level.<br><br>If you already have an NFR subscription, the appliance with the most CUs becomes the NFR. If the number of CUs is equal, the one created earlier will remain the NFR.",
  "create_trial_btn": "Start Trial",
  "nfr_one_accept_prepare_content": "I understood how it works",
  "nfr_one_label": "NFR",
  "sso_info_text": "mypascom looks like this for \"{{name}}\"",
  "partner_subscription_new_button": "Start New Subscription",
  "partner_customer_subscription_new_button": "Start New Customer Subscription",
  "phonenumber_unavailable_headline": "Numbers not available for selected block size",
  "phonenumber_unavailable_card_headline": "Unfortunately, there are no number blocks available for the selected block size and your area code.",
  "phonenumber_unavailable_card_content": "There are currently no numbers available for your selected block size and area code. You have the option to change the block size or contact our sales team at sales@pascom.net to order this block size.",
  "phonenumber_unavailable_back_button": "Back to select block size",
  "no_numbers_available": "Numbers not available for selected block size",
  "filter": "Filter",
  "filter_legacy_onsite": "Legacy On-site",
  "filter_legacy_cloud": "Legacy Cloud",
  "filter_pascom_one": "pascom ONE",
  "filter_csp": "CSP",
  "filter_expired_subscriptions": "Show expired pascom ONE subscriptions",
  "no_tickets": "Currently you don't have any tickets",
  "vat": "VAT",
  "order_number_contact_sales_title": "Contact sales department",
  "order_number_contact_sales_headline": "Please contact our sales department (sales@pascom.net)",
  "order_number_contact_sales_text": "You will soon be able to order numbers via my.pascom.net. In the meantime, our sales department (sales@pascom.net) will be happy to help you carry out ordering a number manually.",
  "subscription_minimum_contract_period": "Minimum contract period until",
  "checkout_one_summary_accept_tkg_at": "I expressly waive the application of the provisions for small and micro company pursuant to §§ 129, 130, 135 and 136 TKG 2021. <a href=\"https://www.pascom.net/wp-content/uploads/zustimmungserklaerung-tkg-en-at.pdf\" target=\"_blank\">Explanations</a>",
  "checkout_one_summary_accept_tkg_de": "I am <u>not</u> a small or micro company or a non-profit organization <u>but I am a</u> small or micro business or a non-profit organization <u>and I renounce</u> the regulations on customer protection pursuant to § 71 (3) TKG. <a href=\"https://www.pascom.net/wp-content/uploads/zustimmungserklaerung-tkg-en-de.pdf\" target=\"_blank\">Explanations</a>",
  "support_phone_number_at": "+43 1 9281746 300",
  "support_phone_number_de": "+49 991 29691 300",
  "support_phone_number_ch": "+49 991 29691 300",
  "support_contact_support_number": "Contact support on {{number}}",
  "subscription_actual_concurrent_user": "{{cu}} Concurrent User",
  "subscription_actual_concurrent_user_details": "You booked <b>{{ cu }} concurrent users</b>. <a href=\"https://www.pascom.net/en/voip-prices/#benefits\" target=\"_blank\">What is a Concurrent User?</a>",
  "subscription_actual_concurrent_user_end_term_note": "You can add more users at any time. Lowering the number of users is possible at the end of the minimum contract period. But you can make this change now and we will execute it on {{ date }} automatically.",
  "subscription_actual_concurrent_user_end_term_note_noadmin": "To change the number of concurrent users, please contact your system administrator.",
  "subscription_actual_sla": "Service Level Agreement ({{ sla }})",
  "subscription_actual_sla1_details": "You booked <b>SLA1</b>, Reaction Time <b>Next</b> Business Day, Support Hours <b>Mo-Fr, 09:00-17:00</b> (Public Holidays excluded)",
  "subscription_actual_sla2_details": "You booked <b>SLA2</b>, Reaction Time <b>4h</b>, Support Hours <b>Mo-Fr, 09:00-18:00</b> (Public Holidays excluded)",
  "subscription_actual_sla3_details": "You booked <b>SLA3</b>, Reaction Time <b>2h</b>, Support Hours <b>Everyday, 08:00-20:00</b>",
  "subscription_actual_sla_end_term_note": "You can upgrade your SLA at any time. A downgrade is possible at the end of the minimum contract period. But you can make this change now and we will execute it on {{date}} automatically.",
  "subscription_actual_sla_end_term_note_noadmin": "To change the SLA, please contact your system administrator.",
  "subscription_change_users": "Change Users",
  "subscription_change_sla": "Change SLA",
  "subscription_credit": "Credit",
  "subscription_credit_details": "You have a credit <i class=\"fa fa-coins red\"></i> of <b>{{ credit }}</b>.",
  "subscription_credit_note": "The credit will automatically be deducted from future monthly bills until it is completely used up.",
  "sla_product_downgrade": "Downgrade",
  "confirm_cancel_customer_subscription_text": "Your Partner created a request to cancel your subscription <b>[{{applianceId}}] {{applianceName}}</b> at the end of the <b>minimum contract period on {{date}}</b>. In order to complete the end of term cancellation, your Partner needs your approval. Please confirm at the bottom of this page that you agree cancel the subscription specified above.<br><br><b>This cancellation will only take place after the minimum contract period has expired on {{date}}.</b><br><br>If you did not request this, you can ignore this request and your subscription will continue as normal.<br><br>On any questions, please contact your partner.",
  "confirm_cancel_customer_subscription_accept_term": "I have read the above text and agree to the cancellation at the end of the minimum contract period on {{date}}.",
  "confirm_cancel_customer_done_headline": "Done!",
  "confirm_cancel_customer_done_content": "The request created by your Partner has been approved and confirmed by you.",
  "subscription_one_trial_details": "You are using a <b>pascom ONE Trial</b> instance, which will run for <b>{{ daysLeft }} day(s)</b>.",
  "subscription_one_trial_note": "You have {{daysLeft}} day(s) left on your pascom ONE Trial. You can upgrade to a full pascom ONE at any time during your trial period and continue working with all your data and settings. At the end of the trial period, the instance will be stopped.",
  "upgrade_one_cu_error_same": "You have selected the same number of concurrent users that exist already in your subscription.",
  "upgrade_one_sla_error_same": "You have selected the same SLA that exist already in your subscription.",
  "downgrade_cu_info_accept_term": "I have read the above text and agree to the downgrade of concurrent users at the end of the minimum contract period on {{date}}.",
  "downgrade_cu_headline": "Downgrade Concurrent Users",
  "downgrade_cu_text": "You want to downgrade your concurrent users from {{oldCU}} to {{newCU}}. This will happen after the minimum contract period.",
  "downgrade_cu_note": "Lowering the number of users is possible at the end of the minimum contract period. But you can make this change now and we will execute it on {{ date }} automatically.",
  "downgrade_sla_headline": "Downgrade SLA",
  "downgrade_sla_text": "You want to downgrade your SLA from {{oldSLA}} to {{newSLA}}. This will happen after the minimum contract period.",
  "downgrade_sla_note": "A downgrade is possible at the end of the minimum contract period. But you can make this change now and we will execute it on {{date}} automatically.",
  "downgrade_sla_info_accept_term": "I have read the above text and agree to the downgrade of the SLA at the end of the minimum contract period on {{date}}.",
  "downgrade_cu_ordered_text": "The users will be lowered to {{ cu }} CU's on {{ date }}.",
  "downgrade_sla_ordered_text": "The SLA will be downgraded to {{ sla }} on {{ date }}.",
  "cancel_order": "Cancel Order",
  "upgrade_users": "Upgrade Users",
  "downgrade_users": "Downgrade Users",
  "select_users": "Select Users",
  "downgrade_users_hint": "You will <b>reduce</b> the number of <b>users</b> from <b>{{oldCU}} to {{newCU}}</b>.",
  "upgrade_users_hint": "You will <b>upgrade</b> the number of <b>users</b> from <b>{{oldCU}} to {{newCU}}</b>.",
  "confirm_cancel_order": "Confirm cancel order",
  "confirm_cancel_order_text": "You will cancel the current order if you proceed.",
  "order_complete": "Order Steps Complete",
  "endcustomer_upgrade_order_complete_headline": "Thank You!",
  "endcustomer_upgrade_order_complete_content": "Your order has been successfully placed. Please check your subscription overview for more details.",
  "endcustomer_downgrade_order_complete_headline": "Order placed!",
  "endcustomer_downgrade_order_complete_content": "Your order has been successfully placed, and will be executed automatically after the minimum contract period. Please check your subscription overview for the minimum contract period date and more details.",
  "back_subscription_details": "Back to Subscription",
  "partner_offer_sent": "Offer Sent",
  "partner_upgrade_offer_sent_headline": "Offer was sent to {{ email }}!",
  "partner_upgrade_offer_sent_content": "We sent the offer to your customer ({{ email }}). The order will be processed when he accepts the offer and you will be notified by email. You can see the state of the offer directly in my.pascom.net.",
  "checkout_delivery_date": "Order execution date: {{date}}",
  "checkout_delivery_date_text": "The earliest possible <b>execution date</b> of this order will be the <b>{{date}}</b>. Due to the minimum contract period, your order cannot be processed until this time.",
  "checkout_delivery_date_term": "Execute the order on {{date}}.",
  "subscription_expires_on_text": "The subscription has been canceled and will expire on {{date}}.",
  "subscription_expired_on_text": "The subscription has been canceled and has expired since {{date}}.",
  "subscription_undo_cancellation_text": "To proceed with <b>{{workflow}}</b>, you must <b>undo the subscription cancllation</b>. Do you want to undo the cancellation?",
  "subscription_undo_cancellation_button": "Yes! Undo subscription cancellation.",
  "configure_otp": "Configure OTP",
  "configure_otp_confirm_header": "Do you want to configure OTP?",
  "configure_otp_confirm_messages": "You can configure OTP to secure your login. You will see a new page with OTP activation details (for security reasons, you may need to log in again). Once configured, this step cannot be undone.",
  "cannot_change_tenant": "We could not switch to the selected tenant. Please try again.",
  "invalid_company_address": "The company address you entered is invalid. Please check your information and try again.",
  "api-message_invalid_zip_code": "The ZIP code you entered is invalid. Please check your information and try again.",
  "api-message_street_house_number_split_failed": "The street address could not be split into street name and house number. Please enter both and try again.",
  "api-message_house_number_format_invalid": "The declared street name does not include any numbers in its last part, that is supposed to be the premises number. The right street name format is \"Mystreet 1a\" and not \"Mystreet 1 a\". Please check your address and correct it.",
  "subscription_already_cancelled": "The subscription has already been cancelled!",
  "subscription_already_cancelled_content": "The subscription cancellation offer created by your Partner has been approved and confirmed by you.",
  "start_trial_now": "Start a FREE 30 day trial now",
  "error_trial_create_sale_order_partner": "pascom ONE trial could not be created. Does your customer already have a running or cancelled pascom ONE trial?",
  "error_trial_create_sale_order": "pascom ONE trial could not be created. Does you already have a running or cancelled pascom ONE trial?",
  "account": "Account",
  "mypascom_settings": "Settings",
  "manage_account": "Manage account",
  "profile": "Profile",
  "my_profile": "My Profile",
  "my_company": "My company",
  "manage_account_profile_hint": "You can change you password, or setup and manage your OTP via the pascom Account Manager. Please click the \"{{linkName}}\" link below to open the Account Manager.",
  "fallback_number_headline": "Fallback phone number",
  "change_fallback_number_headline": "Change fallback phone number",
  "fallback_number_details": "Your current fallback phone number is <b>{{fallbackNumber}}</b>.",
  "fallback_number_not_configured": "Your fallback phone number is <b>not configured</b>.",
  "fallback_number_note": "You can enter an optional telephone number to which all calls will be forwarded if your system is not available.",
  "fallback_number_button": "Change fallback phone number",
  "fallback_number_number_label": "Fallback phone number",
  "fallback_number_placeholder": "Your fallback phone number e.g. 123987654",
  "fallback_number_number_error_phoneNumber": "The entered phone number is invalid. The phone number must begin with the area code, followed by the number, e.g., 123987654.",
  "fallback_number_number_error_required": "The phone number field is required.",
  "fallback_number_remove": "Remove",
  "fallback_number_confirm": "Do you really want to remove the fallback number?",
  "fallback_number_number_error_max_length": "The entered fallback phone number, excluding leading 0, cannot be longer than {{size}} digits.",
  "partner_media_link": "https://www.pascom{{envExtension}}.net/{{countryCode}}/pascom-partner-downloads/",
  "disabled_account_page_header": "Account Disabled",
  "disabled_account_text": "The <b>account</b> is currently <b>deactivated</b>, so login is not possible. Please contact the <b>Support-Team</b> for further assistance.",
  "instance_name_not_unique": "The entered instance name must be unique. Please choose a different name to proceed.",
  "contact_doesnt_relate_to_appliance": "The contact doesn't relate to any appliance.",
  "not_reseller_for_appliance": "This is not a valid reseller for this appliance.",
  "not_a_csp_partner": "Company is not a CSP partner",
  "appliance_already_has_a_test_number": "Appliance already has a Trial phone number",
  "appliance_is_not_a_trial": "Appliance is not a Trial.",
  "endcustomer_need_pascom_approval_headline": "Thank you for your order",
  "endcustomer_need_pascom_approval_content": "Your order is currently being processed. We kindly ask for your understanding that the order approval may take up to one business day.",
  "account_in_approval": "Your order is currently awaiting approval.",
  "lac_no_filtered": "We could not find an appropriate Location Area Code (LAC) for your location. Please check the list above to see if a matching location is available; if not, please contact our sales department (sales@pascom.net).",
  "select_lac_headline": "Location Area Code (LAC)",
  "select_lac": "Select Location Area Code (LAC)",
  "select_lac_button": "Select this Location Area Code",
  "sdd_mandate_identifier": "Mandate Reference",
  "subscription_minimum_term_until": "Minimum contract term:",
  "subscription_start_date": "Start date:",
  "demo_system_label": "Demo System",
  "subscription_demo_system_note": "You can upgrade to a full pascom ONE at any time during your trial period and continue working with all your data and settings.",
  "missing_vat": "VAT number information could not be found.",
  "missing_payment_details": "Payment information is missing or incomplete.",
  "missing_contract_info": "Contract data is missing or incomplete.",
  "missing_trading_license": "The Trading Licence could not be found.",
  "partnership_request_already_exists": "A partnership request already exists.",
  "cannot_create_affiliate": "A partnership could not be created.",
  "cannot_create_attachment": "The attachment could not be created or edited.",
  "subscription_trunks": "Trunks (used in last 30 days)",
  "trunk_filter": "Trunk: {{name}}",
  "subscription_open_appliance": "Open telephone system",
  "subscription_trial_tariff_headline": "Telephone tariff",
  "subscription_trial_tariff_note": "You are currently using Trial Tariff. The following restrictions apply to outgoing calls under this plan: ",
  "subscription_trial_tariff_restriction1": "A permanent spending limit of €10 applies",
  "subscription_trial_tariff_restriction2": "Outgoing calls are only permitted within Germany; special service numbers are excluded.",
  "subscription_trial_tariff_footer": "For unrestricted use of telephony services, you have the option to port an existing phone number to pascom or to acquire a new one.",
  "subscription_trial_tariff_button": "Switch now",
  "subscription-trial-ai-tariff-infos_headline": "AI-Agent-Tariff",
  "subscription-trial-ai-tariff-infos_note": "Your Trial includes the use of AI-Agent-Tariff <b>Pia Start</b> with the following restriction: ",
  "subscription-trial-ai-tariff-infos_restriction": "You have 10 inclusive minutes. Once these are spent, further use is not possible.",
  "subscription-trial-ai-tariff-infos_footer": "For unrestricted use of AI-Agents you have the option to upgrade your subscription and switch tariff.",
  "subscription_license_exceeded_headline": "License Exceeded Notification",
  "subscription_license_exceeded_description_enabled": "License Exceeded Notification is <b>enabled</b>.",
  "subscription_license_exceeded_description_disabled": "License Exceeded Notification is <b>disabled</b>.",
  "subscription_license_exceeded_info": "Enable or disable email notifications when your subscription license limit is exceeded.",
  "subscription_invoice_type_headline": "Invoice Format",
  "subscription_invoice_type_description": "Your current invoice format is <b>{{type}}</b>.",
  "subscription_invoice_type_info": "You can choose between the following invoice formats: {{possibleTypes}}.",
  "subscription_invoice_type_edit_button": "Edit Invoice Format",
  "xrechnung": "XRechnung",
  "pdf": "PDF",
  "pdf_xrechnung": "PDF & XRechnung",
  "subscription_reference_headline": "Your reference for this subscription",
  "subscription_reference_label": "Reference",
  "subscription_reference_placeholder": "Reference e.g. {{ code }}",
  "subscription_reference_description": "To identify this subscription, you can assign a reference number here. This reference number will appear on every monthly invoice.",
  "subscription_reference_active_description": "The selected reference is <b>{{ reference }}</b>.",
  "subscription_reference_edit_button": "Edit reference",
  "subscription_reference_error_required": "This field is mandatory",
  "subscription_reference_error_pattern": "Please use only letters (A-Z, a-z), numbers (0-9), hyphens (-) and underscores (_). Length: 3-80 characters.",
  "invalid_reference_format": "Please check that the reference contains only letters (A-Z, a-z), numbers (0-9), hyphens (-) and underscores (_), and is between 3 and 80 characters long.",
  "invoice_attachment_download": "Download {{format}}",
  "save_draft": "Save draft",
  "save_draft_description": "Save your progress and continue later. Your phone numbers, contact information, and form data will be preserved. You can save a draft before uploading your phone bill.",
  "save_as_draft_continue_later": "Save as draft and continue later",
  "draft_saved": "Draft saved",
  "draft_saved_description": "The information was saved. You can close this or click on the link below to get back to the phone number overview.",
  "close": "Close",
  "save_failed": "Save Failed",
  "continue": "Continue",
  "continue_draft_tooltip": "Continue with this draft",
  "delete_draft_tooltip": "Delete this draft",
  "not_available": "Not available",
  "number_from": "Number from",
  "number_to": "Number to",
  "phone_numbers": "Phone numbers",
  "port_phone_number": "Port phone number",
  "remove": "Remove",
  "show_less": "Show less",
  "show_more": "Show more",
  "unknown_person": "Unknown person",
  "upload_phone_bill": "Upload phone bill",
  "upload_port_form": "Upload port form",
  "port_phonenumber_drafts": "Port phone number drafts",
  "port_number_draft_text": "We found phone number port drafts for this appliance <b>[{{id}}] {{name}}</b>. Do you want to continue with this saved draft, or begin a new port?",
  "drafts": "Drafts",
  "block_phone_number": "Block phone number",
  "from": "From",
  "to": "To",
  "single_phone_numbers_one": "Single phone number",
  "single_phone_numbers_other": "Single phone numbers",
  "no_drafts": "No drafts",
  "navigation_drafts": "Drafts",
  "draft_deleted_successfully": "Draft deleted successfully",
  "port_draft_continue_new": "Start a new porting",
  "base_price_card_selected": "Your current selection",
  "availability_headline": "Availability Level",
  "availability_standard": "Standard",
  "availability_premium": "Premium",
  "availability_beta": "Beta",
  "availability_header_text": "Select an availability level",
  "availability_active_level_description": "You are currently on the <b>{{current}}</b> availability level.",
  "availability_note_standard": "You can upgrade your pascom telephony instance to Premium at any time. This provides benefits such as better predictability, higher stability, and improved performance. For more information, click the upgrade button.",
  "availability_button_change": "Change availability level",
  "availability_body_headline": "Benefits",
  "availability_standard_body": "<b>Standard Features:</b><br>You receive the standard pascom features.",
  "availability_button_standard": "Switch to Standard",
  "availability_premium_body": "<b>Always the most stable version:</b><br>pascom distributes updates in the following order: Standard and Premium. This ensures you use the most thoroughly tested software.<br></br><b>Always informed about updates and maintenance:</b><br>Unlike Standard operation, you will be notified of scheduled maintenance or updates at least 12 hours in advance. This way you know exactly when pascom.cloud will be unavailable due to maintenance.<br></br><b>Performance gain:</b><br>The significantly lower packing density of customer systems ensures sufficient performance for your system. This is particularly advantageous with many active users, API requests, reports, bulk imports, etc.",
  "availability_button_premium": "Switch to Premium",
  "availability_note_premium": "The Premium availability level provides you with the most thoroughly tested software. A switch to another level is possible at the end of the billing period. You can make this change now and we will automatically implement it at the next billing period.",
  "availability_downgrade_premium_confirm_headline": "Cancel Premium Availability Level",
  "availability_downgrade_premium_confirm_text": "You are about to cancel the Premium availability level. This will result in losing the stated benefits and switching back to the Standard level at the next billing period.",
  "availability_downgrade_premium_confirm_btn": "Yes, cancel and switch to Standard.",
  "availability_downgrade_premium_confirm_btn_cancel": "No! Do not cancel and keep the benefits of the Premium availability level.",
  "availability_downgrade_premium_confirm_btn_partner": "Send offer to {{email}}.",
  "availability_downgrade_premium_confirm_offer_accept_term": "I have read the above text and agree to the cancellation at the end of the next billing period.",
  "availability_downgrade_premium_confirm_offer_text": "Your partner has created a request to <b>cancel the Premium availability level</b> for the subscription <b>{{applianceName}}</b> and switch back to the Standard level at the next billing period.<br><br>To complete the cancellation at the end of the billing period, your partner requires your consent.<br>Please confirm at the end of this page that you agree to the <b>cancellation of the Premium availability level</b>.<br><br>This cancellation will only take effect after the next billing period expires.<br><br>If you did not request this, you can ignore this request and your availability level will continue as usual.<br><br>If you have any questions, please contact your partner.",
  "availabilty_description_changing_level": "You are currently on the {{current}} availability level. You will switch to <b>{{next}}</b> at the <b>next billing period on {{date}}</b>.",
  "cancel_order_headline": "Cancel Order",
  "cancel_order_text": "If you continue, you will cancel the current order and continue using your currently selected availability level.",
  "cancel_order_confirm_button": "Yes, cancel order",
  "cancel_order_cancel_button": "Cancel! Continue with order.",
  "invoice_pdf": "PDF Invoice",
  "invoice_xrechnung": "XRechnung",
  "itemized_bill_pdf": "Itemized Bill",
  "no_invoices": "No invoices",
  "search_invoices": "Search invoices",
  "availability_contact_sales_button": "Back to subscription",
  "availability_contact_sales": "Changing the availability level is not possible. Our sales team (sales@pascom.net) is happy to assist you.",
  "fair_flat_price_prefix": "From",
  "tariff_fair_flats": "Fair Flat (inclusive minutes)",
  "tariff_flat_full": "Full Flat",
  "tariff_body_headline": "Benefits",
  "fair_flat_benefits": "<b>Inclusive Minutes:</b><br>You choose from a contingent of available minutes.",
  "full_flat_benefits": "<b>Maximum Flexibility:</b><br>You receive maximum flexibility and cost control",
  "fair_flat_type_select_button": "Select Fair Flat",
  "full_flat_select_button": "Select Full Flat",
  "per_user_per_month": "per month per user",
  "per_instance_per_month": "per month per instance",
  "street_error_required": "Mandatory field",
  "house_number_error_required": "Mandatory field",
  "zip_error_required": "Mandatory field",
  "city_error_required": "Mandatory field",
  "missing_parameters": "Missing parameters",
  "block_not_active": "The phone number block is not active",
  "block_not_linked_to_appliance_subscription": "The phone number block is not linked to the appliance subscription",
  "partner_is_company": "The selected customer must be a contact person, not a company",
  "missing_reseller": "The reseller assignment is missing",
  "reseller_mismatch": "The selected customer does not belong to the same partner as this phone number block",
  "partner_offer_expired_headline": "Your offer has expired",
  "partner_offer_expired_content": "The offer created by your partner has expired. Please contact your partner for a new offer.",
  "button_text_understood": "Got it",
  "upload_failed": "Upload failed",
  "draft_saving_description": "Saving your draft...",
  "draft_save_error_description": "The draft could not be saved. Please try again.",
  "draft_save_retry": "Retry",
  "draft_save_failed_description": "Saving is currently not possible. Please close the porting process and try again later.",
  "draft_save_close_without_saving": "Close without saving",
  "support_ticket_state_unknown": "unknown",
  "support_ticket_state_new": "new",
  "support_ticket_state_wait_on_contact": "reply recieved",
  "support_ticket_state_wait_on_us": "waiting for reply",
  "support_ticket_state_wait_on_dev": "waiting for development",
  "support_ticket_state_wait_on_appointment": "waiting for appointment",
  "support_ticket_state_wait_on_close": "pending close",
  "support_ticket_state_closed": "closed",
  "support_ticket_state_unrecognized": "unrecognized",
  "support_ticket_upload_files_error": "An error occurred while uploading the file(s)",
  "support_ticket_create_success": "Ticket created",
  "support_ticket_create_error": "An error occurred while creating the ticket",
  "support_ticket_get_list_error": "An error occurred while fetching the tickets",
  "support_ticket_get_details_error": "An error occurred while fetching the details of the ticket",
  "support_ticket_close_error": "An error occurred while closing the ticket",
  "support_ticket_download_attachment": "An error occurred while fetching the attachment",
  "support_ticket_add_conversation_entry_error": "An error occurred while sending the message",
  "filter_closed_tickets_text": "Show closed tickets",
  "integration_apps_hub_headline": "Integration Apps Hub",
  "integration_apps_own_headline": "Your Apps",
  "integration_apps_installed_headline": "Installed Apps",
  "integration_apps_marketplace_headline": "Integration Apps Marketplace",
  "integration_apps_button_marketplace": "Add App from Marketplace",
  "integration_apps_search_hub_placeholder": "Search Hub for Apps...",
  "integration_apps_search_placeholder": "Search Apps...",
  "integration_apps_search_subscriptions_placeholder": "Search Subscriptions...",
  "integration_app_marketplace_visible": "Marketplace App",
  "integration_app_marketplace_invisible": "Unlisted App",
  "no_integration_apps_hub": "Currently we could not find any integration apps.",
  "no_marketplace_integration_apps": "Currently we could not find any integration apps on the marketplace.",
  "integration_apps_install_hint": "Install",
  "integration_apps_already_installed_hint": "Already installed",
  "integration_apps_upgrade_hint": "Upgrade",
  "integration_apps_uninstall_hint": "Uninstall",
  "integration_apps_dialog_header_subscriptions": "Choose Subscription",
  "integration_apps_dialog_header_permissions": "App requires permissions",
  "integration_apps_dialog_header_resources": "Import resources",
  "integration_apps_dialog_header_upgrade_resources": "Upgrade: Import resources",
  "integration_apps_dialog_header_confirm_uninstallation": "Uninstall Integration App",
  "integration_apps_dialog_header_summary": "Summary",
  "integration_apps_details_header": "Integration App Details",
  "no_integration_app_details": "The App Details could not be retrieved.",
  "integration_apps_details_card_header": "App Information",
  "label_name": "Name:",
  "label_type": "Type:",
  "label_label": "Label",
  "label_ai_agent": "AI-Agent",
  "label_documentation_url": "Documentation:",
  "label_support_email": "Support Email:",
  "label_vendor": "Vendor:",
  "label_website_url": "Website:",
  "label_privacy_policy_url": "Privacy Policy:",
  "label_description": "Description:",
  "label_installations": "Installations",
  "integration_apps_details_installed_header": "Installed",
  "no_subscriptions_with_integration_app_installed": "No subscriptions with this integration App found.",
  "no_integration_app_on_this_subscription_installed": "Currently this subscription has no integration apps. Find available ones on the marketplace.",
  "no_subscription_to_install_this_integration_app": "There is no subscription to install this Integration App on.",
  "integration_apps_uninstall_info_text": "Are you sure you want to uninstall this Integration App?",
  "app_approve": "Approve",
  "integration_apps_toast_installation_success": "App installation started",
  "integration_apps_toast_installation_error": "App could not be installed",
  "integration_apps_toast_uninstallation_success": "App uninstallation started",
  "integration_apps_toast_uninstallation_error": "App could not be uninstalled",
  "integration_apps_preselected_subscription_info": "Choose an App for",
  "integration_apps_preselected_subscription_info_btn": "Install on [{{preselectedSubId}}] {{preselectedSubName}}",
  "integration_apps_load_resources_error": "An Error occurred while retrieving the resources",
  "integration_apps_retry_installation_error": "An Error occurred during the retry",
  "integration_apps_fetch_installation_status_error": "Failed to refresh the status of the installations",
  "integration_apps_load_apps_error": "An Error occurred while retrieving the Integration Apps",
  "integration_apps_app_details_error": "The Integration App Details could not be found",
  "integration_apps_app_list_error": "The Integration Apps could not be found",
  "integration_apps_start_installation_error": "An error occurred at the start of the installation",
  "integration_apps_start_uninstallation_error": "An error occurred at the start of the uninstallation",
  "integration_apps_installation_state": "(installing)",
  "integration_apps_uninstallation_state": "(uninstalling)",
  "subscription-view_load_integration_apps_error": "An Error occurred while retrieving the Integration Apps",
  "subscription-view_installed_integration_apps_headline": "Installed Apps",
  "subscription-view_integration_apps_marketplace_btn": "Add App from Marketplace",
  "subscription-view_integration_apps_uninstall_hint": "Uninstall",
  "subscription-view_no_integration_apps_installed": "Currently this subscription has no integration apps. Find available ones on the marketplace.",
  "phonenumber_cancel_headline": "Cancel Number",
  "summary_headline": "Summary",
  "cancel_location_dependent_number_info_text": "The following number will be cancelled at the end of the minimum contract period on {{ cancellationDate }}.<br>You may revoke the cancellation at any time prior to this date.",
  "cancel_location_independent_number_info_text": "The following number will be cancelled immediately. You will not be able to revoke the cancellation.",
  "cancel_location_dependent_number_checkbox_text": "I have read the above text and agree to the cancellation of this number at the end of the minimum contract period on {{ cancellationDate }}.",
  "cancel_location_independent_number_checkbox_text": "I have read the above text and agree to the immediate cancellation of this number.",
  "cancel_order_exists": "A cancellation order for this number already exists",
  "cancel_phonenumber_order_complete_headline": "Order placed",
  "cancel_independent_phonenumber_order_complete_headline": "Number cancelled",
  "endcustomer_cancel_phonenumber_order_complete_content": "Your order has been successfully placed, and your number will be cancelled automatically after the minimum contract period. Please check your subscription overview for the minimum contract period date and more details.",
  "endcustomer_cancel_independent_phonenumber_order_complete_content": "The number has been successfully cancelled. You can find your active numbers and further details in your subscription overview.",
  "cancel_phonenumber_cancel_order_info_text": "This number will be cancelled automatically on {{date}}.",
  "ai-tariff-card_headline": "AI-Agent-Tariff",
  "ai-tariff-card_current_ai_tariff_text": "You are using \"{{ currentAiTariff }}\". You can change the tariff any time for the next billing period.",
  "ai-tariff-card_ordered_ai_tariff_text": "You are using \"{{ currentAiTariff }}\". You will change to \"{{ orderedAiTariff }}\" on {{date}}. You can change the tariff any time for the next billing period.",
  "ai-tariff-card_cancel_order_btn": "Cancel Order",
  "ai-tariff-card_choose_tariff_btn": "Choose Tariff",
  "ai-tariff-card_pascom_ai_tariff_a": "Pia Start",
  "ai-tariff-card_pascom_ai_tariff_b": "Pia Plus",
  "ai-tariff-card_pascom_ai_tariff_c": "Pia Pro",
  "ai-tariff-select_choose_headline": "Choose a Tariff",
  "ai-tariff-select_pascom_ai_tariff_a": "Pia Start",
  "ai-tariff-select_pascom_ai_tariff_b": "Pia Plus",
  "ai-tariff-select_pascom_ai_tariff_c": "Pia Pro",
  "ai-tariff-select_price_prefix": "From",
  "ai-tariff-select_price_per_month": "per Month",
  "ai-tariff-select_btn_select_ai_tariff_a": "Select Pia Start",
  "ai-tariff-select_btn_select_ai_tariff_b": "Select Pia Plus",
  "ai-tariff-select_btn_select_ai_tariff_c": "Select Pia Pro",
  "ai-tariff-select_body_headline": "Benefits",
  "ai-tariff-select_included_minutes": "Inclusive Minutes: <b>{{ inclusiveMinutes }}</b>",
  "ai-tariff-select_overshoot_minutes": "Price for each additional minute started: <b>{{ priceOvershootMinute }}</b>",
  "ai-tariff-select_vat_not_included": "* All prices are net plus VAT.",
  "workflow-csp-ai-tariff_load_resource_error": "The AI-Agent Tariffs could not be loaded",
  "workflow-csp-ai-tariff_change_tariff_request_error": "An error occurred while changing the AI-Tariff",
  "workflow-csp-ai-tariff_confirm_offer_error": "An error occurred while confirming the offer",
  "workflow-csp-ai-tariff_a": "Pia Start",
  "workflow-csp-ai-tariff_b": "Pia Plus",
  "workflow-csp-ai-tariff_c": "Pia Pro",
  "workflow-csp-ai-tariff-order-cancel_confirm_headline": "Cancel Order",
  "workflow-csp-ai-tariff-order-cancel_confirm_text": "You will cancel the current order if you proceed. You can change another tariff afterwards.",
  "workflow-csp-ai-tariff-order-cancel_confirm_btn": "Proceed with cancel",
  "workflow-csp-ai-tariff-order-cancel_cancel_btn": "Cancel! Continue with order.",
  "workflow-endcustomer-ai-tariff_load_resource_error": "The AI-Agent Tariffs could not be loaded",
  "workflow-endcustomer-ai-tariff_change_tariff_request_error": "An error occurred while changing the AI-Tariff",
  "workflow-endcustomer-ai-tariff_confirm_offer_error": "An error occurred while confirming the offer",
  "workflow-endcustomer-ai-tariff_a": "Pia Start",
  "workflow-endcustomer-ai-tariff_b": "Pia Plus",
  "workflow-endcustomer-ai-tariff_c": "Pia Pro",
  "workflow-endcustomer-ai-tariff-order-cancel_confirm_headline": "Cancel Order",
  "workflow-endcustomer-ai-tariff-order-cancel_confirm_text": "You will cancel the current order if you proceed. You can change another tariff afterwards.",
  "workflow-endcustomer-ai-tariff-order-cancel_confirm_btn": "Proceed with cancel",
  "workflow-endcustomer-ai-tariff-order-cancel_cancel_btn": "Cancel! Continue with order.",
  "workflow-partner-ai-tariff_load_resource_error": "The AI-Agent Tariffs could not be loaded",
  "workflow-partner-ai-tariff_change_tariff_request_error": "An error occurred while changing the AI-Tariff",
  "workflow-partner-ai-tariff_confirm_offer_error": "An error occurred while confirming the offer",
  "workflow-partner-ai-tariff_a": "Pia Start",
  "workflow-partner-ai-tariff_b": "Pia Plus",
  "workflow-partner-ai-tariff_c": "Pia Pro",
  "workflow-partner-ai-tariff-order-cancel_confirm_headline": "Cancel Order",
  "workflow-partner-ai-tariff-order-cancel_confirm_text": "You will cancel the current order if you proceed. You can change another tariff afterwards.",
  "workflow-partner-ai-tariff-order-cancel_confirm_btn": "Proceed with cancel",
  "workflow-partner-ai-tariff-order-cancel_cancel_btn": "Cancel! Continue with order.",
  "select-phonenumber-type_acquire_limit_reached_message": "You have reached the limit for the number of phone numbers you can acquire at the same time. If you think this is an error, please contact our sales department.",
  "api-message_max_phone_number_count_reached": "You have reached the maximum number of phone numbers you can acquire at the same time. If you think this is an error, please contact our sales department.",
  "integration-apps-hub_create_new_app_btn": "Create new Integration App",
  "integration-apps-hub_no_own_apps": "You don't have created own integration apps yet.",
  "integration-apps-hub_no_installed_apps": "Currently we can't find any installed integration apps.",
  "integration-apps-creation-editor_headline": "Integration App Definition",
  "integration-apps-creation-editor_app_information_tab": "App Information",
  "integration-apps-creation-editor_api_permissions_tab": "API Permissions",
  "integration-apps-creation-editor_api_permissions_doc_link_description": "You can find a detailed description of the permissions here: ",
  "integration-apps-creation-editor_available_permissions_header": "Available: ",
  "integration-apps-creation-editor_selected_permissions_header": "Selected: ",
  "integration-apps-creation-editor_instance_provisioning_tab": "Instance Provisioning",
  "integration-apps-creation-editor_add_label_btn": "Add Label",
  "integration-apps-creation-editor_create_new_version_button_text": "Create new App version",
  "integration-apps-creation-editor_create_new_app_button_text": "Create Integration App",
  "integration-apps-creation-editor_load_existing_app_error": "An error occurred while loading the Integration App",
  "integration-apps-creation-editor_create_app_success": "The Integration App has been created",
  "integration-apps-creation-editor_create_app_error": "An error occurred while creating the Integration App",
  "integration-apps-creation-editor_upgrade_app_success": "A new Version of the Integration App has been created",
  "integration-apps-creation-editor_upgrade_app_error": "An error occurred while creating a new Version of the Integration App",
  "integration-apps-creation-editor_remove_instance_provisioning_entry_header": "Delete Entry",
  "integration-apps-creation-editor_remove_instance_provisioning_entry_message": "Are you sure, that the entry should be deleted?",
  "integration-app-information-form_edit_logo_text": "Edit Logo",
  "integration-app-information-form_add_logo_text": "Choose Logo*",
  "integration-app-information-form_load_logo_failed": "Failed to load the selected logo",
  "integration-app-information-form_invalid_logo_dimensions": "The logo must be {{ width }}x{{ height }} px",
  "list-select_search_placeholder": "Search...",
  "type_label": "Type",
  "on_uninstall_label": "On Uninstall",
  "key_label": "Key",
  "key_error_required": "Mandatory field",
  "visible_label": "Visibility",
  "integration-apps_type_options_label": "Label",
  "integration-apps_uninstall_options_keep": "Keep",
  "integration-apps_uninstall_options_remove": "Remove",
  "integration-apps_label_type_options_generic": "Generic",
  "integration-apps_label_type_options_skill": "Skill",
  "integration-apps_label_visibility_options_visible": "Visible",
  "integration-apps_label_visibility_options_invisible": "Invisible",
  "integration-apps-service_installation_started_state": "Installation started",
  "integration-apps-service_installation_progress_state": "Installing",
  "integration-apps-service_installed_state": "Installed",
  "integration-apps-service_installation_failed_state": "Installation failed",
  "integration-apps-service_uninstallation_started_state": "Uninstallation started",
  "integration-apps-service_uninstallation_progress_state": "Uninstalling",
  "integration-apps-service_uninstalled_state": "Uninstalled",
  "integration-apps-service_uninstallation_failed_state": "Uninstallation failed",
  "integration-apps-service_unknown_state": "Unknown state",
  "integration-apps-instance-provisioning-dialog_select_entry_type_header": "Select Instance Provisioning Type",
  "integration-apps-instance-provisioning-dialog_create_entry_header": "Create Entry",
  "integration-apps-instance-provisioning-dialog_edit_entry_header": "Edit Entry",
  "integration-apps-instance-provisioning-dialog_btn_add": "Add",
  "integration-apps-instance-provisioning-dialog_btn_save_changes": "Save Changes",
  "integration-apps-instance-provisioning-type-card_label_header": "Label",
  "integration-apps-instance-provisioning-type-card_label_description": "Add a label to the app",
  "integration-apps-instance-provisioning-type-card_prompt_header": "Prompt",
  "integration-apps-instance-provisioning-type-card_prompt_description": "Add a prompt to the app",
  "integration-apps-detail-card_new_app_version_text": "Create new Version",
  "integration-apps-detail-card_latest_app_version": "Version: {{appVersion}}",
  "integration-apps-detail-card_display_vendor": "by {{vendor}}",
  "integration-apps-permission-secrets_new_explanation_text": "This secret is used by the Integration App to authenticate its requests to your telephony system.<br>It is only valid for the actions listed below. Please store it securely.",
  "integration-apps-permission-secrets_existing_explanation_text": "There already exists a secret for your installation. It is now valid for the following actions:",
  "integration-apps-permission-secrets_copied_hint": "Secret copied to clipboard",
  "integration-apps-permission-secrets_scope_text_contacts_read": "Read contact data, including labels",
  "integration-apps-permission-secrets_scope_text_contacts_write": "Create, update, and delete contacts, including label assignments",
  "integration-apps-permission-secrets_scope_text_tasks_read": "Read task data from the telephony system",
  "integration-apps-permission-card_display_vendor": "by {{vendor}}",
  "integration-apps-permission-card_confirm_text": "I understand that i grant access to my telephony system to share data between this app and the system.",
  "integration-apps-permission-card_resources_info_text": "This app will import the following resources into your telephony system. Confirm to install the app.",
  "integration-apps-permission-card_resources_upgrade_info_text": "With this upgrade, the app will import the following resources into your telephony system. Confirm to install the latest version of the app.",
  "integration-apps-permission-card_generic_label_label": "Generic Label:",
  "integration-apps-permission-card_skill_label_label": "Skill-Label:",
  "integration-apps-permission-card_label_label": "Label:",
  "integration-apps-permission-card_ai_agent_label": "AI-Agent:",
  "integration-apps-permission-card_name_label": "Name:",
  "instance-provisioning-label-form_label_header": "Label",
  "name_label": "Name",
  "app_name_label": "App name",
  "name_error_required": "Mandatory field",
  "documentation_label": "Documentation:",
  "documentation_url_label": "Documentation",
  "documentation_url_error_required": "Mandatory field",
  "documentation_url_error_url": "Invalid URL",
  "support_email_label": "Support email",
  "support_email_error_required": "Mandatory field",
  "support_email_error_email": "Invalid Email",
  "vendor_label": "Vendor",
  "vendor_error_required": "Mandatory field",
  "website_label": "Website:",
  "website_url_label": "Website",
  "website_url_error_required": "Mandatory field",
  "website_url_error_url": "Invalid URL",
  "privacy_policy_label": "Privacy policy:",
  "privacy_policy_url_label": "Privacy policy",
  "privacy_policy_url_error_required": "Mandatory field",
  "privacy_policy_url_error_url": "Invalid URL",
  "description_label": "Description",
  "description_error_required": "Mandatory field",
  "integration_apps_dialog_header_permission_secrets": "Permissions",
  "integration_apps_dialog_header_upgrade_permission_secrets": "Upgrade: Permissions",
  "integration-apps-permission-secrets_new_confirm_text": "I made sure to remember the secret and i understand it can not be recovered by anyone.",
  "integration-apps-permission-secrets_existing_confirm_text": "I understand that my secret is now valid for the actions shown.",
  "integration-apps-permission-secrets_identifier_value": "for: {{ identifier }}",
  "subscription-card_upgrade_btn_text": "Upgrade available",
  "subscription-card_retry_btn_text": "Retry",
  "integration-apps-card_display_vendor": "by {{vendor}}",
  "integration-apps-card_marketplace_visible": "Marketplace App",
  "integration-apps-card_marketplace_invisible": "Unlisted App",
  "integration-apps-card_already_installed_hint": "Already installed",
  "integration-apps-card-long_display_vendor": "by {{vendor}}"
}
